// import React from 'react'
// import Layout from '../components/layout'
// import { Line } from "react-chartjs-2";
// import { Bar } from "react-chartjs-2";
// import { Pie } from "react-chartjs-2";
// import { Doughnut } from "react-chartjs-2";
// import "chart.js/auto";

// function Analytics() {

//     const data = {
//         churnRate: {
//             labels: ["JAN", "FEB", "MAR", "APR"],
//             datasets: [
//                 {
//                     label: "Churn Rate",
//                     data: [2.5, 2.2, 2.8, 2.0],
//                     borderColor: "#c7852a",
//                     backgroundColor: "rgba(199, 133, 42, 0.2)",
//                     borderWidth: 2,
//                 },
//             ],
//         },
//         engagement: {
//             labels: ["Website Visits", "App Usage", "Support Tickets"],
//             datasets: [
//                 {
//                     label: "Engagement Metrics",
//                     data: [15000, 12000, 500],
//                     backgroundColor: "#c7852a",

//                 },
//             ],
//         },
//         retentionRate: {
//             labels: ["Loans", "Investments", "Credit Cards", "Savings"],
//             datasets: [
//                 {
//                     label: "Retention Rate",
//                     data: [92, 85, 88, 90],
//                     backgroundColor: ["#c7852a", "#b4741f", "#a46315", "#8a5210"],
//                 },
//             ],
//         },
//     };
//     const barOptions = {
//         indexAxis: 'y',
//       };

//     return (
//         <Layout>
//             <div className="p-6 bg-[#F9F5F1] h-full flex flex-col items-center overflow-scroll hide-scrollbar">
//                 <h1 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-[#b4741f] mb-6">Customer Retention Report</h1>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-6xl">
//                     {/* Churn Rate Over Time */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary">
//                         <h2 className="text-[#b4741f] font-bold">CHURN RATE OVER TIME</h2>
//                         <Line data={data.churnRate} />
//                     </div>

//                     {/* Customer Engagement Metrics */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary">
//                         <h2 className="text-[#b4741f] font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
//                         <Bar data={data.engagement} />
//                     </div>

//                     {/* Retention Rate by Product/Service */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary flex flex-col justify-evenly items-center">
//                         <h2 className="text-[#b4741f] font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
//                         <Pie data={data.retentionRate}  className="max-h-96 max-w-96"/>
//                     </div>
//                     {/* Retention Rate by Product/Service */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary flex flex-col justify-evenly items-center">
//                         <h2 className="text-[#b4741f] font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
//                         <Doughnut data={data.retentionRate}  className="max-h-96 max-w-96"/>
//                     </div>
//                     {/* Customer Engagement Metrics */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary md:col-span-2 ">
//                         <h2 className="text-[#b4741f] font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
//                         <Bar data={data.engagement} options={barOptions}/>
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     )
// }

// export default Analytics

// import React from 'react'
// import Layout from '../components/layout'
// import { Line } from "react-chartjs-2";
// import { Bar } from "react-chartjs-2";
// import { Pie } from "react-chartjs-2";
// import { Doughnut } from "react-chartjs-2";
// import "chart.js/auto";

// function Analytics() {
//     const data = {
//         churnRate: {
//             labels: ["JAN", "FEB", "MAR", "APR"],
//             datasets: [
//                 {
//                     label: "Churn Rate",
//                     data: [2.5, 2.2, 2.8, 2.0],
//                     borderColor: "#3B82F6", // Matches --light-primary-color
//                     backgroundColor: "rgba(59, 130, 246, 0.2)", // Light primary with opacity
//                     borderWidth: 2,
//                 },
//             ],
//         },
//         engagement: {
//             labels: ["Website Visits", "App Usage", "Support Tickets"],
//             datasets: [
//                 {
//                     label: "Engagement Metrics",
//                     data: [15000, 12000, 500],
//                     backgroundColor: "#9CA3AF", // Matches --secondary-color
//                     borderColor: "#1E3A8A", // Matches --primary-color
//                     borderWidth: 1,
//                 },
//             ],
//         },
//         retentionRate: {
//             labels: ["Loans", "Investments", "Credit Cards", "Savings"],
//             datasets: [
//                 {
//                     label: "Retention Rate",
//                     data: [92, 85, 88, 90],
//                     backgroundColor: [
//                         "#1E3A8A", // Matches --primary-color
//                         "#2563EB", // Darker shade of light-primary
//                         "#3B82F6", // Matches --light-primary-color
//                         "#60A5FA", // Lighter shade of light-primary
//                     ],
//                     borderColor: "#D1D5DB", // Matches --light-secondary-color
//                     borderWidth: 1,
//                 },
//             ],
//         },
//     };

//     const barOptions = {
//         indexAxis: 'y',
//     };

//     return (
//         <Layout>
//             <div className="p-6 bg-light-secondary h-full flex flex-col items-center">
//                 <h1 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-primary mb-6">Customer Retention Report</h1>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-6xl">
//                     {/* Churn Rate Over Time */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary">
//                         <h2 className="text-primary font-bold">CHURN RATE OVER TIME</h2>
//                         <Line data={data.churnRate} />
//                     </div>

//                     {/* Customer Engagement Metrics */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary">
//                         <h2 className="text-primary font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
//                         <Bar data={data.engagement} />
//                     </div>

//                     {/* Retention Rate by Product/Service (Pie) */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary flex flex-col justify-evenly items-center">
//                         <h2 className="text-primary font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
//                         <Pie data={data.retentionRate} className="max-h-96 max-w-96" />
//                     </div>

//                     {/* Retention Rate by Product/Service (Doughnut) */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary flex flex-col justify-evenly items-center">
//                         <h2 className="text-primary font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
//                         <Doughnut data={data.retentionRate} className="max-h-96 max-w-96" />
//                     </div>

//                     {/* Customer Engagement Metrics (Horizontal Bar) */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-primary md:col-span-2">
//                         <h2 className="text-primary font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
//                         <Bar data={data.engagement} options={barOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     )
// }

// export default Analytics

// import React, { useState } from 'react';
// import Layout from '../components/layout';
// import { Bar, Doughnut, Radar, Scatter, PolarArea, Bubble } from "react-chartjs-2";
// import "chart.js/auto";

// function Analytics() {
//     const [selectedApp, setSelectedApp] = useState('whatsapp');
//     const [startDate, setStartDate] = useState('2025-04-01');
//     const [endDate, setEndDate] = useState('2025-04-08');

//     // Static data for all ten analytics metrics
//     const botCustomerCareData = {
//         labels: ['Resolved by Bot', 'Escalated to Agent', 'Unresolved'],
//         datasets: [
//             {
//                 data: selectedApp === 'whatsapp' ? [70, 20, 10] :
//                       selectedApp === 'telegram' ? [65, 25, 10] :
//                       selectedApp === 'infobip' ? [68, 22, 10] :
//                       [66, 23, 11], // Wati
//                 backgroundColor: ['#1A5276', '#48BBF9', '#F87171'],
//             },
//         ],
//     };

//     const marketingPromotionData = {
//         labels: ['Clicks', 'Conversions', 'Bounces'],
//         datasets: [
//             {
//                 label: 'Campaign Performance',
//                 data: selectedApp === 'whatsapp' ? [500, 150, 100] :
//                       selectedApp === 'telegram' ? [450, 130, 120] :
//                       selectedApp === 'infobip' ? [480, 140, 110] :
//                       [460, 135, 115], // Wati
//                 backgroundColor: '#48BBF9',
//             },
//         ],
//     };

//     const conversationalCommerceData = {
//         datasets: [
//             {
//                 label: 'Order Value vs Time',
//                 data: selectedApp === 'whatsapp' ? [
//                     { x: 1, y: 50 }, { x: 2, y: 75 }, { x: 3, y: 100 }, { x: 4, y: 60 }, { x: 5, y: 120 }
//                 ] : selectedApp === 'telegram' ? [
//                     { x: 1, y: 45 }, { x: 2, y: 65 }, { x: 3, y: 90 }, { x: 4, y: 55 }, { x: 5, y: 110 }
//                 ] : selectedApp === 'infobip' ? [
//                     { x: 1, y: 48 }, { x: 2, y: 70 }, { x: 3, y: 95 }, { x: 4, y: 58 }, { x: 5, y: 115 }
//                 ] : [
//                     { x: 1, y: 46 }, { x: 2, y: 68 }, { x: 3, y: 92 }, { x: 4, y: 57 }, { x: 5, y: 112 }
//                 ], // Wati
//                 backgroundColor: '#1A5276',
//                 borderColor: '#48BBF9',
//                 pointRadius: 5,
//             },
//         ],
//     };

//     const botFeatureUsageData = {
//         labels: ['Customer Care', 'Marketing', 'Commerce', 'Analytics'],
//         datasets: [
//             {
//                 label: 'Bot Feature Usage',
//                 data: selectedApp === 'whatsapp' ? [85, 75, 65, 60] :
//                       selectedApp === 'telegram' ? [80, 70, 60, 55] :
//                       selectedApp === 'infobip' ? [82, 72, 63, 58] :
//                       [83, 73, 62, 57], // Wati
//                 backgroundColor: 'rgba(72, 187, 249, 0.6)',
//                 borderColor: '#48BBF9',
//                 borderWidth: 2,
//             },
//         ],
//     };

//     const botEngagementData = {
//         labels: ['Quick Replies', 'Menu Selections', 'Free Text', 'Abandoned'],
//         datasets: [
//             {
//                 data: selectedApp === 'whatsapp' ? [40, 30, 20, 10] :
//                       selectedApp === 'telegram' ? [35, 25, 25, 15] :
//                       selectedApp === 'infobip' ? [38, 28, 22, 12] :
//                       [36, 27, 23, 14], // Wati
//                 backgroundColor: ['#1A5276', '#48BBF9', '#A9A9A9', '#F87171'],
//             },
//         ],
//     };

//     const costEfficiencyData = {
//         datasets: [
//             {
//                 label: 'Cost vs Conversations',
//                 data: selectedApp === 'whatsapp' ? [
//                     { x: 100, y: 0.05, r: 10 }, { x: 200, y: 0.04, r: 15 }, { x: 300, y: 0.03, r: 20 }
//                 ] : selectedApp === 'telegram' ? [
//                     { x: 90, y: 0.06, r: 10 }, { x: 180, y: 0.05, r: 15 }, { x: 270, y: 0.04, r: 20 }
//                 ] : selectedApp === 'infobip' ? [
//                     { x: 95, y: 0.055, r: 10 }, { x: 190, y: 0.045, r: 15 }, { x: 285, y: 0.035, r: 20 }
//                 ] : [
//                     { x: 92, y: 0.057, r: 10 }, { x: 184, y: 0.047, r: 15 }, { x: 276, y: 0.037, r: 20 }
//                 ], // Wati
//                 backgroundColor: '#48BBF9',
//             },
//         ],
//     };

//     const userDemographicsData = {
//         labels: ['18-25', '26-35', '36-45', '46-55', '56+'],
//         datasets: [
//             {
//                 label: 'User Age Distribution',
//                 data: selectedApp === 'whatsapp' ? [25, 35, 20, 15, 5] :
//                       selectedApp === 'telegram' ? [20, 30, 25, 15, 10] :
//                       selectedApp === 'infobip' ? [22, 33, 22, 13, 10] :
//                       [23, 32, 23, 14, 8], // Wati
//                 backgroundColor: 'rgba(26, 82, 118, 0.7)',
//                 borderColor: '#1A5276',
//                 borderWidth: 2,
//             },
//         ],
//     };

//     const campaignROIData = {
//         labels: ['Campaign 1', 'Campaign 2', 'Campaign 3'],
//         datasets: [
//             {
//                 label: 'ROI (%)',
//                 data: selectedApp === 'whatsapp' ? [120, 150, 90] :
//                       selectedApp === 'telegram' ? [110, 130, 85] :
//                       selectedApp === 'infobip' ? [115, 140, 88] :
//                       [112, 135, 87], // Wati
//                 backgroundColor: '#48BBF9',
//             },
//         ],
//     };

//     const numberOfConversationsData = {
//         labels: ['Bot-Initiated', 'User-Initiated', 'Follow-Ups'],
//         datasets: [
//             {
//                 label: 'Conversation Breakdown',
//                 data: selectedApp === 'whatsapp' ? [800, 1200, 400] :
//                       selectedApp === 'telegram' ? [700, 1000, 350] :
//                       selectedApp === 'infobip' ? [750, 1100, 380] :
//                       [720, 1050, 360], // Wati
//                 backgroundColor: ['#1A5276', '#48BBF9', '#A9A9A9'],
//             },
//         ],
//     };

//     const walletPointsUsageData = {
//         datasets: [
//             {
//                 label: 'Points Spent vs Redeemed',
//                 data: selectedApp === 'whatsapp' ? [
//                     { x: 100, y: 50, r: 10 }, { x: 200, y: 80, r: 15 }, { x: 300, y: 120, r: 20 }
//                 ] : selectedApp === 'telegram' ? [
//                     { x: 90, y: 45, r: 10 }, { x: 180, y: 70, r: 15 }, { x: 270, y: 100, r: 20 }
//                 ] : selectedApp === 'infobip' ? [
//                     { x: 95, y: 48, r: 10 }, { x: 190, y: 75, r: 15 }, { x: 285, y: 110, r: 20 }
//                 ] : [
//                     { x: 92, y: 46, r: 10 }, { x: 184, y: 72, r: 15 }, { x: 276, y: 105, r: 20 }
//                 ], // Wati
//                 backgroundColor: '#1A5276',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: { legend: { position: 'top' } },
//     };

//     const scatterOptions = {
//         ...chartOptions,
//         scales: {
//             x: { title: { display: true, text: 'Days (April 2025)' } },
//             y: { title: { display: true, text: 'Order Value ($)' } },
//         },
//     };

//     const bubbleOptions = {
//         ...chartOptions,
//         scales: {
//             x: { title: { display: true, text: 'Conversations' } },
//             y: { title: { display: true, text: 'Cost per Conversation ($)' } },
//         },
//     };

//     const walletBubbleOptions = {
//         ...chartOptions,
//         scales: {
//             x: { title: { display: true, text: 'Points Spent' } },
//             y: { title: { display: true, text: 'Points Redeemed' } },
//         },
//     };

//     const apps = [
//         { value: 'whatsapp', label: 'WhatsApp' },
//         { value: 'telegram', label: 'Telegram' },
//         { value: 'infobip', label: 'Infobip' },
//         { value: 'wati', label: 'Wati' },
//     ];

//     return (
//         <Layout>
//             <div className="p-6 bg-light-secondary min-h-screen">
//                 <h1 className="text-2xl font-semibold text-primary mb-6">Comprehensive Bot Analytics</h1>

//                 {/* Filters */}
//                 <div className="bg-white p-4 rounded-xl shadow-md mb-6 flex flex-col md:flex-row gap-4 items-center">
//                     <div className="flex-1">
//                         <label className="text-primary font-medium mb-2 block">Select Application</label>
//                         <select
//                             value={selectedApp}
//                             onChange={(e) => setSelectedApp(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-light-primary"
//                         >
//                             {apps.map((app) => (
//                                 <option key={app.value} value={app.value}>
//                                     {app.label}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="flex-1">
//                         <label className="text-primary font-medium mb-2 block">Start Date</label>
//                         <input
//                             type="date"
//                             value={startDate}
//                             onChange={(e) => setStartDate(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-light-primary"
//                         />
//                     </div>
//                     <div className="flex-1">
//                         <label className="text-primary font-medium mb-2 block">End Date</label>
//                         <input
//                             type="date"
//                             value={endDate}
//                             onChange={(e) => setEndDate(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-light-primary"
//                         />
//                     </div>
//                 </div>

//                 {/* Charts */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {/* Bot Customer Care Performance */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Bot Customer Care Performance</h2>
//                         <div className="h-64">
//                             <Doughnut data={botCustomerCareData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Marketing Promotion Effectiveness */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Marketing Promotion Effectiveness</h2>
//                         <div className="h-64">
//                             <Bar data={marketingPromotionData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Conversational Commerce Trends */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversational Commerce Trends</h2>
//                         <div className="h-64">
//                             <Scatter data={conversationalCommerceData} options={scatterOptions} />
//                         </div>
//                     </div>

//                     {/* Bot Feature Usage */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Bot Feature Usage</h2>
//                         <div className="h-64">
//                             <Radar data={botFeatureUsageData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Bot Engagement Patterns */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Bot Engagement Patterns</h2>
//                         <div className="h-64">
//                             <PolarArea data={botEngagementData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Cost Efficiency */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Cost Efficiency</h2>
//                         <div className="h-64">
//                             <Bubble data={costEfficiencyData} options={bubbleOptions} />
//                         </div>
//                     </div>

//                     {/* User Demographics */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">User Demographics</h2>
//                         <div className="h-64">
//                             <Radar data={userDemographicsData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Campaign ROI */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Campaign ROI</h2>
//                         <div className="h-64">
//                             <Bar data={campaignROIData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Number of Conversations */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Number of Conversations</h2>
//                         <div className="h-64">
//                             <Doughnut data={numberOfConversationsData} options={chartOptions} />
//                         </div>
//                     </div>

//                     {/* Wallet Points Usage */}
//                     <div className="bg-white p-4 rounded-xl shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Wallet Points Usage</h2>
//                         <div className="h-64">
//                             <Bubble data={walletPointsUsageData} options={walletBubbleOptions} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Analytics;

// import React, { useState } from 'react';
// import { Bar, Doughnut } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
// import Layout from '../components/layout';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

// function Analytics() {
//     const [selectedApp, setSelectedApp] = useState('whatsapp');
//     const [startDate, setStartDate] = useState('2025-04-01');
//     const [endDate, setEndDate] = useState('2025-04-08');
//     const [timePeriod, setTimePeriod] = useState('daily');

//     // Static data for analytics
//     const analyticsData = {
//         whatsapp: {
//             chatVolumes: { today: 2156, monthAvg: 2000, yearAvg: 1800 },
//             topQueries: ['Billing Issues', 'Product Queries', 'Technical Support'],
//             csat: { today: 4.2, monthAvg: 4.0, yearAvg: 3.9 },
//             feedbackFillRate: '85%',
//             escalationRate: { today: 15, monthAvg: 12, yearAvg: 10 },
//             pendingTickets: { '24h': 20, '48h': 15, '72h': 5, '>72h': 5 },
//             closureTime: '2m 30s',
//             errors: { today: 2, monthAvg: 1.5, yearAvg: 1 },
//             abandonedRate: '12%',
//             upRatedBot: 600,
//             downRatedBot: 50,
//             ticketsCreated: 200,
//             humanInvolved: 300,
//         },
//         telegram: {
//             chatVolumes: { today: 1900, monthAvg: 1800, yearAvg: 1700 },
//             topQueries: ['Technical Support', 'Billing Issues', 'Product Queries'],
//             csat: { today: 4.0, monthAvg: 3.8, yearAvg: 3.7 },
//             feedbackFillRate: '80%',
//             escalationRate: { today: 18, monthAvg: 15, yearAvg: 13 },
//             pendingTickets: { '24h': 25, '48h': 10, '72h': 8, '>72h': 7 },
//             closureTime: '2m 45s',
//             errors: { today: 3, monthAvg: 2, yearAvg: 1.8 },
//             abandonedRate: '14%',
//             upRatedBot: 550,
//             downRatedBot: 60,
//             ticketsCreated: 180,
//             humanInvolved: 280,
//         },
//         infobip: {
//             chatVolumes: { today: 2000, monthAvg: 1900, yearAvg: 1750 },
//             topQueries: ['Billing Issues', 'Technical Support', 'Product Queries'],
//             csat: { today: 4.1, monthAvg: 3.9, yearAvg: 3.8 },
//             feedbackFillRate: '82%',
//             escalationRate: { today: 16, monthAvg: 13, yearAvg: 11 },
//             pendingTickets: { '24h': 22, '48h': 12, '72h': 6, '>72h': 6 },
//             closureTime: '2m 40s',
//             errors: { today: 2.5, monthAvg: 1.8, yearAvg: 1.2 },
//             abandonedRate: '13%',
//             upRatedBot: 580,
//             downRatedBot: 55,
//             ticketsCreated: 190,
//             humanInvolved: 290,
//         },
//         wati: {
//             chatVolumes: { today: 1950, monthAvg: 1850, yearAvg: 1700 },
//             topQueries: ['Product Queries', 'Billing Issues', 'Technical Support'],
//             csat: { today: 4.0, monthAvg: 3.8, yearAvg: 3.7 },
//             feedbackFillRate: '81%',
//             escalationRate: { today: 17, monthAvg: 14, yearAvg: 12 },
//             pendingTickets: { '24h': 23, '48h': 11, '72h': 7, '>72h': 6 },
//             closureTime: '2m 50s',
//             errors: { today: 2.8, monthAvg: 1.9, yearAvg: 1.3 },
//             abandonedRate: '14%',
//             upRatedBot: 560,
//             downRatedBot: 58,
//             ticketsCreated: 185,
//             humanInvolved: 285,
//         },
//     };

//     const conversationBreakdownData = {
//         labels: ['Up-Rated Bot', 'Down-Rated Bot', 'Tickets Created', 'Human Involved'],
//         datasets: [
//             {
//                 data: [
//                     analyticsData[selectedApp].upRatedBot,
//                     analyticsData[selectedApp].downRatedBot,
//                     analyticsData[selectedApp].ticketsCreated,
//                     analyticsData[selectedApp].humanInvolved,
//                 ],
//                 backgroundColor: ['#1A5276', '#F87171', '#48BBF9', '#A9A9A9'],
//             },
//         ],
//     };

//     const pendingTicketsData = {
//         labels: ['24h', '48h', '72h', '>72h'],
//         datasets: [
//             {
//                 label: 'Pending Tickets',
//                 data: Object.values(analyticsData[selectedApp].pendingTickets),
//                 backgroundColor: '#1A5276',
//             },
//         ],
//     };

//     const chatVolumeData = {
//         labels: ['Today', 'Month Avg', 'Year Avg'],
//         datasets: [
//             {
//                 label: 'Chat Volumes',
//                 data: [
//                     analyticsData[selectedApp].chatVolumes.today,
//                     analyticsData[selectedApp].chatVolumes.monthAvg,
//                     analyticsData[selectedApp].chatVolumes.yearAvg,
//                 ],
//                 backgroundColor: '#48BBF9',
//             },
//         ],
//     };

//     const csatData = {
//         labels: ['Today', 'Month Avg', 'Year Avg'],
//         datasets: [
//             {
//                 label: 'CSAT Score',
//                 data: [
//                     analyticsData[selectedApp].csat.today,
//                     analyticsData[selectedApp].csat.monthAvg,
//                     analyticsData[selectedApp].csat.yearAvg,
//                 ],
//                 backgroundColor: '#1A5276',
//             },
//         ],
//     };

//     const escalationRateData = {
//         labels: ['Today', 'Month Avg', 'Year Avg'],
//         datasets: [
//             {
//                 label: 'Escalation Rate (%)',
//                 data: [
//                     analyticsData[selectedApp].escalationRate.today,
//                     analyticsData[selectedApp].escalationRate.monthAvg,
//                     analyticsData[selectedApp].escalationRate.yearAvg,
//                 ],
//                 backgroundColor: '#48BBF9',
//             },
//         ],
//     };

//     const errorRateData = {
//         labels: ['Today', 'Month Avg', 'Year Avg'],
//         datasets: [
//             {
//                 label: 'Error Rate (%)',
//                 data: [
//                     analyticsData[selectedApp].errors.today,
//                     analyticsData[selectedApp].errors.monthAvg,
//                     analyticsData[selectedApp].errors.yearAvg,
//                 ],
//                 backgroundColor: '#F87171',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: { legend: { position: 'top' } },
//     };

//     const apps = [
//         { value: 'whatsapp', label: 'WhatsApp' },
//         { value: 'telegram', label: 'Telegram' },
//         { value: 'infobip', label: 'Infobip' },
//         { value: 'wati', label: 'Wati' },
//     ];

//     return (
//         <Layout>
//             <div className="p-6 bg-gray-100 min-h-screen">
//                 <h1 className="text-2xl font-semibold text-primary mb-6">Chatbot Analytics</h1>

//                 {/* Filters */}
//                 <div className="bg-white p-4 rounded-lg shadow-md mb-6 flex flex-row flex-wrap gap-4 items-center w-full">
//     <div className="flex-1 min-w-[200px]">
//         <label className="text-primary font-medium mb-2 block">Start Date</label>
//         <input
//             type="date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//         />
//     </div>
//     <div className="flex-1 min-w-[200px]">
//         <label className="text-primary font-medium mb-2 block">End Date</label>
//         <input
//             type="date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//         />
//     </div>
//     <div className="flex-1 min-w-[200px]">
//         <label className="text-primary font-medium mb-2 block">Time Period</label>
//         <select
//             value={timePeriod}
//             onChange={(e) => setTimePeriod(e.target.value)}
//             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//             <option value="daily">Daily</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//         </select>
//     </div>
// </div>

//                 {/* Analytics Metrics */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Chat Volumes</h2>
//                         <div className="h-64">
//                             <Bar data={chatVolumeData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">CSAT Score</h2>
//                         <div className="h-64">
//                             <Bar data={csatData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Escalation Rate</h2>
//                         <div className="h-64">
//                             <Bar data={escalationRateData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Error Rate</h2>
//                         <div className="h-64">
//                             <Bar data={errorRateData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Pending Tickets</h2>
//                         <div className="h-64">
//                             <Bar data={pendingTicketsData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversation Breakdown</h2>
//                         <div className="h-64">
//                             <Doughnut data={conversationBreakdownData} options={chartOptions} />
//                         </div>
//                     </div>
//                     {/* <div className="bg-white p-4 rounded-lg shadow-md h-auto ">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Top 3 Queries</h2>
//                         <ul className="list-disc pl-5 text-primary text-left">
//                             {analyticsData[selectedApp].topQueries.map((query, index) => (
//                                 <li key={index}>{query}</li>
//                             ))}
//                         </ul>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto ">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Additional Metrics</h2>
//                         <p className="text-primary text-left">Feedback Fill Rate: {analyticsData[selectedApp].feedbackFillRate}</p>
//                         <p className="text-primary text-left">Avg Closure Time: {analyticsData[selectedApp].closureTime}</p>
//                         <p className="text-primary text-left">Abandonment Rate: {analyticsData[selectedApp].abandonedRate}</p>
//                     </div> */}
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Analytics;

// import React, { useState } from 'react';
// import { Bar, Doughnut, Line, Pie, Scatter, Radar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement,
//     RadialLinearScale,
// } from 'chart.js';
// import Layout from '../components/layout';
// import DownloadButton from '../components/downloadButton';
// import Papa from 'papaparse';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, RadialLinearScale);

// function Analytics() {
//     const [selectedApp, setSelectedApp] = useState('whatsapp');
//     const [selectedProperty, setSelectedProperty] = useState('all');
//     const [startDate, setStartDate] = useState('2025-04-01');
//     const [endDate, setEndDate] = useState('2025-04-08');
//     const [timePeriod, setTimePeriod] = useState('daily');

//     // Static data for analytics (mock data for all KPIs, structured for future API)
//     const analyticsData = {
//         whatsapp: {
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 2 },
//                     { date: '2025-04-02', value: 9 },
//                     { date: '2025-04-03', value: 5 },
//                     { date: '2025-04-04', value: 7 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 9 }, { week: 'Week 2', value: 10 }],
//                 monthly: [{ month: '2025-04', value: 10 }, { month: '2025-03', value: 9 }],
//             },
//             conversionRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 6 },
//                     { date: '2025-04-02', value: 8 },
//                     { date: '2025-04-03', value: 7 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 7 }, { week: 'Week 2', value: 8 }],
//                 monthly: [{ month: '2025-04', value: 8 }, { month: '2025-03', value: 7 }],
//             },
//             abandonmentRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 12 },
//                     { date: '2025-04-02', value: 11 },
//                     { date: '2025-04-03', value: 13 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 12 }, { week: 'Week 2', value: 11 }],
//                 monthly: [{ month: '2025-04', value: 12 }, { month: '2025-03', value: 13 }],
//             },
//             csat: {
//                 daily: [
//                     { date: '2025-04-01', value: 4.2 },
//                     { date: '2025-04-02', value: 4.1 },
//                     { date: '2025-04-03', value: 4.3 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 4.2 }, { week: 'Week 2', value: 4.1 }],
//                 monthly: [{ month: '2025-04', value: 4.2 }, { month: '2025-03', value: 4.0 }],
//             },
//             firstContactResolution: {
//                 daily: [
//                     { date: '2025-04-01', value: 700 },
//                     { date: '2025-04-02', value: 710 },
//                     { date: '2025-04-03', value: 690 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 705 }, { week: 'Week 2', value: 700 }],
//                 monthly: [{ month: '2025-04', value: 700 }, { month: '2025-03', value: 690 }],
//             },
//             chatbotEngagement: {
//                 daily: [
//                     { date: '2025-04-01', whatsapp: 1000, website: 800, instagram: 600 },
//                     { date: '2025-04-02', whatsapp: 990, website: 810, instagram: 590 },
//                 ],
//                 weekly: [
//                     { week: 'Week 1', whatsapp: 990, website: 810, instagram: 590 },
//                     { week: 'Week 2', whatsapp: 1000, website: 800, instagram: 600 },
//                 ],
//                 monthly: [
//                     { month: '2025-04', whatsapp: 1000, website: 800, instagram: 600 },
//                     { month: '2025-03', whatsapp: 980, website: 790, instagram: 580 },
//                 ],
//             },
//             avgResponseTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 1.8 },
//                     { date: '2025-04-02', value: 1.7 },
//                     { date: '2025-04-03', value: 1.9 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 1.8 }, { week: 'Week 2', value: 1.7 }],
//                 monthly: [{ month: '2025-04', value: 1.8 }, { month: '2025-03', value: 1.9 }],
//             },
//             actionSuccessRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 85 },
//                     { date: '2025-04-02', value: 86 },
//                     { date: '2025-04-03', value: 84 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 85 }, { week: 'Week 2', value: 86 }],
//                 monthly: [{ month: '2025-04', value: 85 }, { month: '2025-03', value: 84 }],
//             },
//             salesGenerated: {
//                 daily: [
//                     { date: '2025-04-01', cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
//                     { date: '2025-04-02', cartAdditions: 4900, productRecommendations: 3100, dealDiscovery: 1900 },
//                 ],
//                 weekly: [
//                     { week: 'Week 1', cartAdditions: 4900, productRecommendations: 3100, dealDiscovery: 1900 },
//                     { week: 'Week 2', cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
//                 ],
//                 monthly: [
//                     { month: '2025-04', cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
//                     { month: '2025-03', cartAdditions: 4800, productRecommendations: 2900, dealDiscovery: 1800 },
//                 ],
//             },
//             clickThroughRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 25 },
//                     { date: '2025-04-02', value: 24 },
//                     { date: '2025-04-03', value: 26 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 25 }, { week: 'Week 2', value: 24 }],
//                 monthly: [{ month: '2025-04', value: 25 }, { month: '2025-03', value: 23 }],
//             },
//             humanAgentQueueTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 5 },
//                     { date: '2025-04-02', value: 4.8 },
//                     { date: '2025-04-03', value: 5.2 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 5 }, { week: 'Week 2', value: 4.9 }],
//                 monthly: [{ month: '2025-04', value: 5 }, { month: '2025-03', value: 5.1 }],
//             },
//             avgTicketClosureTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 24 },
//                     { date: '2025-04-02', value: 23 },
//                     { date: '2025-04-03', value: 25 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 24 }, { week: 'Week 2', value: 23 }],
//                 monthly: [{ month: '2025-04', value: 24 }, { month: '2025-03', value: 25 }],
//             },
//             bounceRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 15 },
//                     { date: '2025-04-02', value: 14 },
//                     { date: '2025-04-03', value: 16 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 15 }, { week: 'Week 2', value: 14 }],
//                 monthly: [{ month: '2025-04', value: 15 }, { month: '2025-03', value: 16 }],
//             },
//             hoursSaved: {
//                 daily: [
//                     { date: '2025-04-01', value: 120 },
//                     { date: '2025-04-02', value: 118 },
//                     { date: '2025-04-03', value: 122 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 120 }, { week: 'Week 2', value: 119 }],
//                 monthly: [{ month: '2025-04', value: 120 }, { month: '2025-03', value: 118 }],
//             },
//             costSaved: {
//                 daily: [
//                     { date: '2025-04-01', value: 2400 },
//                     { date: '2025-04-02', value: 2350 },
//                     { date: '2025-04-03', value: 2450 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2400 }, { week: 'Week 2', value: 2375 }],
//                 monthly: [{ month: '2025-04', value: 2400 }, { month: '2025-03', value: 2300 }],
//             },
//             heatmap: {
//                 days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
//                 hours: ['12AM', '3AM', '6AM', '9AM', '12PM', '3PM', '6PM', '9PM'],
//                 values: [
//                     [50, 60, 70, 80, 90, 100, 110, 120],
//                     [60, 70, 80, 90, 100, 110, 120, 130],
//                     [70, 80, 90, 100, 110, 120, 130, 140],
//                     [80, 90, 100, 110, 120, 130, 140, 150],
//                     [90, 100, 110, 120, 130, 140, 150, 160],
//                     [100, 110, 120, 130, 140, 150, 160, 170],
//                     [110, 120, 130, 140, 150, 160, 170, 180],
//                 ],
//             },
//             flowEngagement: {
//                 daily: [
//                     { date: '2025-04-01', actionBlock: 'Welcome', count: 1000, exit: 20 },
//                     { date: '2025-04-01', actionBlock: 'Product Inquiry', count: 800, exit: 30 },
//                 ],
//                 weekly: [
//                     { week: 'Week 1', actionBlock: 'Welcome', count: 990, exit: 21 },
//                     { week: 'Week 1', actionBlock: 'Product Inquiry', count: 790, exit: 31 },
//                 ],
//                 monthly: [
//                     { month: '2025-04', actionBlock: 'Welcome', count: 1000, exit: 20 },
//                     { month: '2025-04', actionBlock: 'Product Inquiry', count: 800, exit: 30 },
//                 ],
//             },
//             upRatedConversations: {
//                 daily: [
//                     { date: '2025-04-01', value: 600 },
//                     { date: '2025-04-02', value: 610 },
//                     { date: '2025-04-03', value: 590 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 605 }, { week: 'Week 2', value: 600 }],
//                 monthly: [{ month: '2025-04', value: 600 }, { month: '2025-03', value: 590 }],
//             },
//             downRatedConversations: {
//                 daily: [
//                     { date: '2025-04-01', value: 50 },
//                     { date: '2025-04-02', value: 48 },
//                     { date: '2025-04-03', value: 52 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 50 }, { week: 'Week 2', value: 49 }],
//                 monthly: [{ month: '2025-04', value: 50 }, { month: '2025-03', value: 51 }],
//             },
//             ticketsCreated: {
//                 daily: [
//                     { date: '2025-04-01', value: 200 },
//                     { date: '2025-04-02', value: 195 },
//                     { date: '2025-04-03', value: 205 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 200 }, { week: 'Week 2', value: 198 }],
//                 monthly: [{ month: '2025-04', value: 200 }, { month: '2025-03', value: 195 }],
//             },
//             chatVolumes: {
//                 daily: [
//                     { date: '2025-04-01', value: 2156 },
//                     { date: '2025-04-02', value: 2100 },
//                     { date: '2025-04-03', value: 2200 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2128 }, { week: 'Week 2', value: 2150 }],
//                 monthly: [{ month: '2025-04', value: 2156 }, { month: '2025-03', value: 2100 }],
//             },
//             topQueries: ['Billing Issues', 'Product Queries', 'Technical Support'],
//             csatScore: {
//                 daily: [
//                     { date: '2025-04-01', value: 4.2 },
//                     { date: '2025-04-02', value: 4.1 },
//                     { date: '2025-04-03', value: 4.3 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 4.2 }, { week: 'Week 2', value: 4.1 }],
//                 monthly: [{ month: '2025-04', value: 4.2 }, { month: '2025-03', value: 4.0 }],
//             },
//             feedbackFillRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 85 },
//                     { date: '2025-04-02', value: 84 },
//                     { date: '2025-04-03', value: 86 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 85 }, { week: 'Week 2', value: 84 }],
//                 monthly: [{ month: '2025-04', value: 85 }, { month: '2025-03', value: 83 }],
//             },
//             escalationRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 15 },
//                     { date: '2025-04-02', value: 14 },
//                     { date: '2025-04-03', value: 16 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 15 }, { week: 'Week 2', value: 14 }],
//                 monthly: [{ month: '2025-04', value: 15 }, { month: '2025-03', value: 13 }],
//             },
//             closureTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 2.5 },
//                     { date: '2025-04-02', value: 2.4 },
//                     { date: '2025-04-03', value: 2.6 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2.5 }, { week: 'Week 2', value: 2.4 }],
//                 monthly: [{ month: '2025-04', value: 2.5 }, { month: '2025-03', value: 2.3 }],
//             },
//             errors: {
//                 daily: [
//                     { date: '2025-04-01', value: 2 },
//                     { date: '2025-04-02', value: 1.8 },
//                     { date: '2025-04-03', value: 2.2 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2 }, { week: 'Week 2', value: 1.9 }],
//                 monthly: [{ month: '2025-04', value: 2 }, { month: '2025-03', value: 1.8 }],
//             },
//             abandonedUsers: {
//                 daily: [
//                     { date: '2025-04-01', value: 12 },
//                     { date: '2025-04-02', value: 11 },
//                     { date: '2025-04-03', value: 13 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 12 }, { week: 'Week 2', value: 11 }],
//                 monthly: [{ month: '2025-04', value: 12 }, { month: '2025-03', value: 13 }],
//             },
//             agentAnalytics: {
//                 currentlyServing: {
//                     daily: [
//                         { date: '2025-04-01', value: 10 },
//                         { date: '2025-04-02', value: 12 },
//                         { date: '2025-04-03', value: 11 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 11 }, { week: 'Week 2', value: 12 }],
//                     monthly: [{ month: '2025-04', value: 11 }, { month: '2025-03', value: 10 }],
//                 },
//                 totalServed: {
//                     daily: [
//                         { date: '2025-04-01', value: 500 },
//                         { date: '2025-04-02', value: 510 },
//                         { date: '2025-04-03', value: 490 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 505 }, { week: 'Week 2', value: 500 }],
//                     monthly: [{ month: '2025-04', value: 500 }, { month: '2025-03', value: 490 }],
//                 },
//                 conversationsHandled: {
//                     daily: [
//                         { date: '2025-04-01', value: 50 },
//                         { date: '2025-04-02', value: 52 },
//                         { date: '2025-04-03', value: 48 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 50 }, { week: 'Week 2', value: 51 }],
//                     monthly: [{ month: '2025-04', value: 50 }, { month: '2025-03', value: 49 }],
//                 },
//                 conversationTransfers: {
//                     daily: [
//                         { date: '2025-04-01', value: 20 },
//                         { date: '2025-04-02', value: 18 },
//                         { date: '2025-04-03', value: 22 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 20 }, { week: 'Week 2', value: 19 }],
//                     monthly: [{ month: '2025-04', value: 20 }, { month: '2025-03', value: 21 }],
//                 },
//                 timeToFirstResponse: {
//                     daily: [
//                         { date: '2025-04-01', value: 0.5 },
//                         { date: '2025-04-02', value: 0.4 },
//                         { date: '2025-04-03', value: 0.6 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 0.5 }, { week: 'Week 2', value: 0.4 }],
//                     monthly: [{ month: '2025-04', value: 0.5 }, { month: '2025-03', value: 0.6 }],
//                 },
//                 usualTimeToResponse: {
//                     daily: [
//                         { date: '2025-04-01', value: 0.75 },
//                         { date: '2025-04-02', value: 0.7 },
//                         { date: '2025-04-03', value: 0.8 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 0.75 }, { week: 'Week 2', value: 0.7 }],
//                     monthly: [{ month: '2025-04', value: 0.75 }, { month: '2025-03', value: 0.8 }],
//                 },
//                 conversationDuration: {
//                     daily: [
//                         { date: '2025-04-01', value: 10 },
//                         { date: '2025-04-02', value: 9.5 },
//                         { date: '2025-04-03', value: 10.5 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 10 }, { week: 'Week 2', value: 9.8 }],
//                     monthly: [{ month: '2025-04', value: 10 }, { month: '2025-03', value: 9.7 }],
//                 },
//             },
//             acquisitions: {
//                 country: [
//                     { name: 'USA', chats: 500, contacts: 300 },
//                     { name: 'India', chats: 400, contacts: 250 },
//                 ],
//                 city: [
//                     { name: 'New York', chats: 200, contacts: 120 },
//                     { name: 'Mumbai', chats: 150, contacts: 90 },
//                 ],
//                 state: [
//                     { name: 'CA', chats: 150, contacts: 90 },
//                     { name: 'MH', chats: 100, contacts: 60 },
//                 ],
//                 webpage: [
//                     { name: 'Homepage', chats: 400, contacts: 250 },
//                     { name: 'Product Page', chats: 300, contacts: 180 },
//                 ],
//                 referral: [
//                     { name: 'Google', chats: 300, contacts: 180 },
//                     { name: 'Facebook', chats: 200, contacts: 120 },
//                 ],
//                 utm_source: [
//                     { name: 'email', chats: 100, contacts: 60 },
//                     { name: 'social', chats: 150, contacts: 90 },
//                 ],
//                 utm_medium: [
//                     { name: 'cpc', chats: 200, contacts: 120 },
//                     { name: 'banner', chats: 100, contacts: 60 },
//                 ],
//                 utm_campaign: [
//                     { name: 'spring_sale', chats: 150, contacts: 90 },
//                     { name: 'summer_promo', chats: 100, contacts: 60 },
//                 ],
//             },
//         },
//         telegram: {
//             // Similar structure with different values (mock data)
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 7 },
//                     { date: '2025-04-02', value: 9 },
//                     { date: '2025-04-03', value: 8 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 8 }, { week: 'Week 2', value: 9 }],
//                 monthly: [{ month: '2025-04', value: 9 }, { month: '2025-03', value: 8 }],
//             },
//             // ... other KPIs with similar structure
//         },
//         infobip: {
//             // Similar structure with different values (mock data)
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 9 },
//                     { date: '2025-04-02', value: 10 },
//                     { date: '2025-04-03', value: 8 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 9 }, { week: 'Week 2', value: 10 }],
//                 monthly: [{ month: '2025-04', value: 10 }, { month: '2025-03', value: 9 }],
//             },
//             // ... other KPIs with similar structure
//         },
//         wati: {
//             // Similar structure with different values (mock data)
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 6 },
//                     { date: '2025-04-02', value: 8 },
//                     { date: '2025-04-03', value: 7 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 7 }, { week: 'Week 2', value: 8 }],
//                 monthly: [{ month: '2025-04', value: 8 }, { month: '2025-03', value: 7 }],
//             },
//             // ... other KPIs with similar structure
//         },
//     };

//     // Filter data based on date range
//     const getFilteredData = (data, key) => {
//         const filtered = data[key][timePeriod]?.filter(item => {
//             const itemDate = new Date(item.date || item.week || item.month);
//             const start = new Date(startDate);
//             const end = new Date(endDate);
//             return itemDate >= start && itemDate <= end;
//         });
//         return filtered;
//     };

//     // // Chart type mapping based on time period
//     // const chartTypeMap = {
//     //     engagement: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     conversionRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     abandonmentRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     csat: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     firstContactResolution: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     chatbotEngagement: { daily: 'Bar', weekly: 'Bar', monthly: 'Pie' },
//     //     avgResponseTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     actionSuccessRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     salesGenerated: { daily: 'Pie', weekly: 'Pie', monthly: 'Pie' },
//     //     clickThroughRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     humanAgentQueueTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     avgTicketClosureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     bounceRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     hoursSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     costSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     flowEngagement: { daily: 'Bar', weekly: 'Bar', monthly: 'Pie' },
//     //     conversationBreakdown: { daily: 'Doughnut', weekly: 'Doughnut', monthly: 'Doughnut' },
//     //     chatVolumes: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     csatScore: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     feedbackFillRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     escalationRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     closureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     errors: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     abandonedUsers: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     agentAnalytics: { daily: 'Radar', weekly: 'Radar', monthly: 'Radar' },
//     // };

//     const chartTypeMap = {
//         engagement: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for monthly to show magnitude
//         conversionRate: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for monthly proportions
//         abandonmentRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for simple monthly proportion
//         csat: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea to emphasize CSAT scores
//         firstContactResolution: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for monthly total
//         chatbotEngagement: { daily: 'Bubble', weekly: 'Bar', monthly: 'Doughnut' }, // Bubble for multi-channel daily data
//         avgResponseTime: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for response time magnitude
//         actionSuccessRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for success rate proportion
//         salesGenerated: { daily: 'Doughnut', weekly: 'Doughnut', monthly: 'Doughnut' }, // Doughnut for consistent proportions
//         clickThroughRate: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for CTR magnitude
//         humanAgentQueueTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for queue time proportion
//         avgTicketClosureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for closure time proportion
//         bounceRate: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for bounce rate magnitude
//         hoursSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for total hours saved
//         costSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for total cost saved
//         flowEngagement: { daily: 'Bar', weekly: 'Bar', monthly: 'Doughnut' }, // Doughnut for action block proportions
//         conversationBreakdown: { daily: 'Doughnut', weekly: 'Doughnut', monthly: 'Doughnut' }, // Doughnut for proportions
//         chatVolumes: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for volume magnitude
//         csatScore: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for CSAT score emphasis
//         feedbackFillRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for feedback rate proportion
//         escalationRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for escalation proportion
//         closureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for closure time proportion
//         errors: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for error rate magnitude
//         abandonedUsers: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for abandoned users proportion
//         agentAnalytics: { daily: 'Radar', weekly: 'Radar', monthly: 'Radar' }, // Radar for multi-metric comparison
//         // New Mixed chart for comparing related metrics
//         engagementVsConversion: { daily: 'Mixed', weekly: 'Mixed', monthly: 'Scatter' }, // Added for correlation analysis
//     };

//     // Chart data configurations
//     const engagementChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'engagement').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Engagement %',
//                 data: getFilteredData(analyticsData[selectedApp], 'engagement').map(item => item.value),
//                 borderColor: '#1A5276',
//                 backgroundColor: timePeriod === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//                 fill: chartTypeMap.engagement[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const conversionChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'conversionRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Conversion Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'conversionRate').map(item => item.value),
//                 borderColor: '#F87171',
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#34D399', '#1A5276'] : '#F87171',
//                 fill: chartTypeMap.conversionRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const abandonmentChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'abandonmentRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Abandonment Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'abandonmentRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#FBBF24', '#34D399', '#1A5276'] : '#FBBF24',
//                 borderColor: '#FBBF24',
//                 fill: chartTypeMap.abandonmentRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const csatChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'csat').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'CSAT Score',
//                 data: getFilteredData(analyticsData[selectedApp], 'csat').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#FBBF24', '#1A5276'] : '#34D399',
//                 borderColor: '#34D399',
//                 fill: chartTypeMap.csat[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const firstContactResolutionChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'firstContactResolution').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'First Contact Resolution',
//                 data: getFilteredData(analyticsData[selectedApp], 'firstContactResolution').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#FBBF24', '#34D399'] : '#48BBF9',
//                 borderColor: '#48BBF9',
//                 fill: chartTypeMap.firstContactResolution[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const chatbotEngagementChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'WhatsApp',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.whatsapp),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#48BBF9', '#8B5CF6'] : '#34D399',
//             },
//             {
//                 label: 'Website',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.website),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#34D399', '#8B5CF6'] : '#48BBF9',
//             },
//             {
//                 label: 'Instagram',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.instagram),
//                 backgroundColor: timePeriod === 'monthly' ? ['#8B5CF6', '#34D399', '#48BBF9'] : '#8B5CF6',
//             },
//         ],
//     };

//     const avgResponseTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'avgResponseTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Avg Response Time (s)',
//                 data: getFilteredData(analyticsData[selectedApp], 'avgResponseTime').map(item => item.value),
//                 borderColor: '#EC4899',
//                 backgroundColor: timePeriod === 'monthly' ? ['#EC4899', '#FBBF24', '#34D399'] : '#EC4899',
//                 fill: chartTypeMap.avgResponseTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const actionSuccessRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'actionSuccessRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Action Success Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'actionSuccessRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//                 borderColor: '#1A5276',
//                 fill: chartTypeMap.actionSuccessRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const salesGeneratedChartData = {
//         labels: ['Cart Additions', 'Product Recommendations', 'Deal Discovery'],
//         datasets: [
//             {
//                 data: [
//                     getFilteredData(analyticsData[selectedApp], 'salesGenerated')?.reduce((sum, item) => sum + item.cartAdditions, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'salesGenerated')?.reduce((sum, item) => sum + item.productRecommendations, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'salesGenerated')?.reduce((sum, item) => sum + item.dealDiscovery, 0) || 0,
//                 ],
//                 backgroundColor: ['#1A5276', '#F87171', '#34D399'],
//             },
//         ],
//     };

//     const clickThroughRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'clickThroughRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Click-Through Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'clickThroughRate').map(item => item.value),
//                 borderColor: '#FBBF24',
//                 backgroundColor: timePeriod === 'monthly' ? ['#FBBF24', '#34D399', '#1A5276'] : '#FBBF24',
//                 fill: chartTypeMap.clickThroughRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const humanAgentQueueTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'humanAgentQueueTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Human Agent Queue Time (m)',
//                 data: getFilteredData(analyticsData[selectedApp], 'humanAgentQueueTime').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#8B5CF6', '#FBBF24', '#34D399'] : '#8B5CF6',
//                 borderColor: '#8B5CF6',
//                 fill: chartTypeMap.humanAgentQueueTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const avgTicketClosureTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'avgTicketClosureTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Avg Ticket Closure Time (h)',
//                 data: getFilteredData(analyticsData[selectedApp], 'avgTicketClosureTime').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#EC4899', '#FBBF24', '#34D399'] : '#EC4899',
//                 borderColor: '#EC4899',
//                 fill: chartTypeMap.avgTicketClosureTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const bounceRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'bounceRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Bounce Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'bounceRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#34D399', '#1A5276'] : '#F87171',
//                 borderColor: '#F87171',
//                 fill: chartTypeMap.bounceRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const hoursSavedChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'hoursSaved').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Hours Saved',
//                 data: getFilteredData(analyticsData[selectedApp], 'hoursSaved').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#FBBF24', '#1A5276'] : '#34D399',
//                 borderColor: '#34D399',
//                 fill: chartTypeMap.hoursSaved[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const costSavedChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'costSaved').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Cost Saved ($)',
//                 data: getFilteredData(analyticsData[selectedApp], 'costSaved').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#FBBF24', '#34D399'] : '#48BBF9',
//                 borderColor: '#48BBF9',
//                 fill: chartTypeMap.costSaved[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const heatmapChartData = {
//         labels: analyticsData[selectedApp].heatmap.days,
//         datasets: analyticsData[selectedApp].heatmap.hours.map((hour, index) => ({
//             label: hour,
//             data: analyticsData[selectedApp].heatmap.values.map(row => row[index]),
//             backgroundColor: '#1A5276',
//         })),
//     };

//     const flowEngagementChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'flowEngagement').map(item => item.actionBlock),
//         datasets: [
//             {
//                 label: 'Count',
//                 data: getFilteredData(analyticsData[selectedApp], 'flowEngagement').map(item => item.count),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#F87171', '#34D399'] : '#48BBF9',
//             },
//             {
//                 label: 'Exit %',
//                 data: getFilteredData(analyticsData[selectedApp], 'flowEngagement').map(item => item.exit),
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#48BBF9', '#34D399'] : '#F87171',
//             },
//         ],
//     };

//     const conversationBreakdownChartData = {
//         labels: ['Up-Rated Bot', 'Down-Rated Bot', 'Tickets Created', 'Human Involved'],
//         datasets: [
//             {
//                 data: [
//                     getFilteredData(analyticsData[selectedApp], 'upRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'downRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'ticketsCreated')?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     (getFilteredData(analyticsData[selectedApp], 'chatbotEngagement')?.reduce((sum, item) => sum + item.whatsapp + item.website + item.instagram, 0) || 0) -
//                     (getFilteredData(analyticsData[selectedApp], 'upRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0) -
//                     (getFilteredData(analyticsData[selectedApp], 'downRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0) -
//                     (getFilteredData(analyticsData[selectedApp], 'ticketsCreated')?.reduce((sum, item) => sum + item.value, 0) || 0),
//                 ],
//                 backgroundColor: ['#1A5276', '#F87171', '#48BBF9', '#A9A9A9'],
//             },
//         ],
//     };

//     const chatVolumeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'chatVolumes').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Chat Volumes',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatVolumes').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#FBBF24', '#34D399'] : '#48BBF9',
//                 borderColor: '#48BBF9',
//                 fill: chartTypeMap.chatVolumes[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const csatScoreChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'csatScore').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'CSAT Score',
//                 data: getFilteredData(analyticsData[selectedApp], 'csatScore').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#FBBF24', '#1A5276'] : '#34D399',
//                 borderColor: '#34D399',
//                 fill: chartTypeMap.csatScore[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const feedbackFillRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'feedbackFillRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Feedback Fill Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'feedbackFillRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#FBBF24', '#34D399', '#1A5276'] : '#FBBF24',
//                 borderColor: '#FBBF24',
//                 fill: chartTypeMap.feedbackFillRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const escalationRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'escalationRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Escalation Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'escalationRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#8B5CF6', '#FBBF24', '#34D399'] : '#8B5CF6',
//                 borderColor: '#8B5CF6',
//                 fill: chartTypeMap.escalationRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const closureTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'closureTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Closure Time (m)',
//                 data: getFilteredData(analyticsData[selectedApp], 'closureTime').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#EC4899', '#FBBF24', '#34D399'] : '#EC4899',
//                 borderColor: '#EC4899',
//                 fill: chartTypeMap.closureTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const errorRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'errors').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Error Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'errors').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#34D399', '#1A5276'] : '#F87171',
//                 borderColor: '#F87171',
//                 fill: chartTypeMap.errors[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const abandonedUsersChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'abandonedUsers').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Abandoned Users %',
//                 data: getFilteredData(analyticsData[selectedApp], 'abandonedUsers').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//                 borderColor: '#1A5276',
//                 fill: chartTypeMap.abandonedUsers[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const agentAnalyticsChartData = {
//         labels: ['Currently Serving', 'Total Served', 'Conversations Handled', 'Conversation Transfers', 'Time to First Response', 'Usual Time to Response', 'Conversation Duration'],
//         datasets: [
//             {
//                 label: 'Agent Analytics',
//                 data: [
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.currentlyServing, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.totalServed, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.conversationsHandled, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.conversationTransfers, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.timeToFirstResponse, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.usualTimeToResponse, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.conversationDuration, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                 ],
//                 backgroundColor: 'rgba(139, 92, 246, 0.2)',
//                 borderColor: '#8B5CF6',
//                 fill: true,
//             },
//         ],
//     };

//     const acquisitionsTableData = analyticsData[selectedApp].acquisitions[selectedProperty === 'all' ? 'country' : selectedProperty];

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: function (context) {
//                         return `${context.dataset.label}: ${context.parsed.y || context.parsed}`;
//                     },
//                 },
//             },
//         },
//         scales: {
//             y: {
//                 beginAtZero: true,
//                 title: {
//                     display: true,
//                     text: 'Value',
//                 },
//             },
//             x: {
//                 title: {
//                     display: true,
//                     text: timePeriod.charAt(0).toUpperCase() + timePeriod.slice(1),
//                 },
//             },
//         },
//     };

//     const pieChartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: function (context) {
//                         return `${context.label}: ${context.parsed}`;
//                     },
//                 },
//             },
//         },
//     };

//     const radarChartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//         },
//         scales: {
//             r: {
//                 beginAtZero: true,
//                 suggestedMin: 0,
//                 suggestedMax: 1000,
//             },
//         },
//     };

//     // Function to get the appropriate chart component
//     const getChartComponent = (chartType) => {
//         switch (chartType) {
//             case 'Line':
//                 return Line;
//             case 'Bar':
//                 return Bar;
//             case 'Pie':
//                 return Pie;
//             case 'Doughnut':
//                 return Doughnut;
//             case 'Radar':
//                 return Radar;
//             default:
//                 return Bar;
//         }
//     };

//     // Function to get chart options based on chart type
//     const getChartOptions = (chartType) => {
//         if (chartType === 'Pie' || chartType === 'Doughnut') {
//             return pieChartOptions;
//         } else if (chartType === 'Radar') {
//             return radarChartOptions;
//         }
//         return chartOptions;
//     };

//     const apps = [
//         { value: 'whatsapp', label: 'WhatsApp' },
//         { value: 'telegram', label: 'Telegram' },
//         { value: 'infobip', label: 'Infobip' },
//         { value: 'wati', label: 'Wati' },
//     ];

//     const properties = [
//         { value: 'all', label: 'All' },
//         { value: 'country', label: 'Country' },
//         { value: 'city', label: 'City' },
//         { value: 'state', label: 'State' },
//         { value: 'webpage', label: 'Webpage' },
//         { value: 'referral', label: 'Referral' },
//         { value: 'utm_source', label: 'UTM Source' },
//         { value: 'utm_medium', label: 'UTM Medium' },
//         { value: 'utm_campaign', label: 'UTM Campaign' },
//     ];

//     // Aggregate all analytics data for DownloadButton
//     const allAnalyticsData = (() => {
//         const allData = [];

//         // Define all metrics to include
//         const metrics = [
//             { key: 'engagement', label: 'Engagement %' },
//             { key: 'conversionRate', label: 'Conversion Rate %' },
//             { key: 'abandonmentRate', label: 'Abandonment Rate %' },
//             { key: 'csat', label: 'CSAT Score' },
//             { key: 'firstContactResolution', label: 'First Contact Resolution' },
//             { key: 'chatbotEngagement', label: 'Chatbot Engagement' },
//             { key: 'avgResponseTime', label: 'Avg Response Time (s)' },
//             { key: 'actionSuccessRate', label: 'Action Success Rate %' },
//             { key: 'salesGenerated', label: 'Sales Generated' },
//             { key: 'clickThroughRate', label: 'Click-Through Rate %' },
//             { key: 'humanAgentQueueTime', label: 'Human Agent Queue Time (m)' },
//             { key: 'avgTicketClosureTime', label: 'Avg Ticket Closure Time (h)' },
//             { key: 'bounceRate', label: 'Bounce Rate %' },
//             { key: 'hoursSaved', label: 'Hours Saved' },
//             { key: 'costSaved', label: 'Cost Saved ($)' },
//             { key: 'flowEngagement', label: 'Flow Engagement' },
//             { key: 'chatVolumes', label: 'Chat Volumes' },
//             { key: 'csatScore', label: 'CSAT Score' },
//             { key: 'feedbackFillRate', label: 'Feedback Fill Rate %' },
//             { key: 'escalationRate', label: 'Escalation Rate %' },
//             { key: 'closureTime', label: 'Closure Time (m)' },
//             { key: 'errors', label: 'Error Rate %' },
//             { key: 'abandonedUsers', label: 'Abandoned Users %' },
//         ];

//         // Add chart data
//         metrics.forEach(({ key, label }) => {
//             const filteredData = getFilteredData(analyticsData[selectedApp], key);
//             filteredData.forEach(item => {
//                 allData.push({
//                     Metric: label,
//                     TimePeriod: timePeriod,
//                     Date: item.date || item.week || item.month || '',
//                     ...item, // Spread item to include all properties (e.g., value, whatsapp, website, instagram)
//                 });
//             });
//         });

//         // Add conversation breakdown
//         conversationBreakdownChartData.labels.forEach((label, index) => {
//             allData.push({
//                 Metric: 'Conversation Breakdown',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Label: label,
//                 Value: conversationBreakdownChartData.datasets[0].data[index],
//             });
//         });

//         // Add agent analytics
//         agentAnalyticsChartData.labels.forEach((label, index) => {
//             allData.push({
//                 Metric: 'Agent Analytics',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Label: label,
//                 Value: agentAnalyticsChartData.datasets[0].data[index],
//             });
//         });

//         // Add acquisitions
//         acquisitionsTableData.forEach(item => {
//             allData.push({
//                 Metric: `Acquisitions by ${selectedProperty === 'all' ? 'Country' : selectedProperty}`,
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Name: item.name,
//                 Chats: item.chats,
//                 Contacts: item.contacts,
//             });
//         });

//         // Add top queries
//         analyticsData[selectedApp].topQueries.forEach((query, index) => {
//             allData.push({
//                 Metric: 'Top Queries',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Rank: index + 1,
//                 Query: query,
//             });
//         });

//         // Add heatmap data
//         analyticsData[selectedApp].heatmap.values.flat().forEach((value, index) => {
//             allData.push({
//                 Metric: 'Heatmap',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Day: analyticsData[selectedApp].heatmap.days[Math.floor(index / 8)],
//                 Hour: analyticsData[selectedApp].heatmap.hours[index % 8],
//                 Engagements: value,
//             });
//         });

//         return allData;
//     })();

//     return (
//         <Layout>
//             <div className="p-6 bg-gray-100 min-h-screen">
//                 {/* <h1 className="text-2xl font-semibold text-primary mb-6">Chatbot Analytics</h1> */}

//                 {/* Download Button for All Analytics */}
//                 <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
//                     <h2 className="text-xl font-semibold text-primary">Download Analytics Data</h2>
//                     <DownloadButton
//                         data={allAnalyticsData}
//                         filename={`analytics_${selectedApp}_${timePeriod}`}
//                     />
//                 </div>

//                 {/* Filters */}
//                 <div className="bg-white p-4 rounded-lg shadow-md mb-6 flex flex-row flex-wrap gap-4 items-center w-full">
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">App</label>
//                         <select
//                             value={selectedApp}
//                             onChange={(e) => setSelectedApp(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         >
//                             {apps.map(app => (
//                                 <option key={app.value} value={app.value}>{app.label}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">Property</label>
//                         <select
//                             value={selectedProperty}
//                             onChange={(e) => setSelectedProperty(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         >
//                             {properties.map(prop => (
//                                 <option key={prop.value} value={prop.value}>{prop.label}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">Start Date</label>
//                         <input
//                             type="date"
//                             value={startDate}
//                             onChange={(e) => setStartDate(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">End Date</label>
//                         <input
//                             type="date"
//                             value={endDate}
//                             onChange={(e) => setEndDate(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">Time Period</label>
//                         <select
//                             value={timePeriod}
//                             onChange={(e) => setTimePeriod(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         >
//                             <option value="daily">Daily</option>
//                             <option value="weekly">Weekly</option>
//                             <option value="monthly">Monthly</option>
//                         </select>
//                     </div>
//                 </div>

//                 {/* Analytics Metrics */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Engagement %</h2>
//                         <div className="h-64">
//                             {engagementChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.engagement[timePeriod]), {
//                                     data: engagementChartData,
//                                     options: getChartOptions(chartTypeMap.engagement[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'engagement')} filename="engagement" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversion Rate</h2>
//                         <div className="h-64">
//                             {conversionChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.conversionRate[timePeriod]), {
//                                     data: conversionChartData,
//                                     options: getChartOptions(chartTypeMap.conversionRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'conversionRate')} filename="conversion_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Abandonment Rate</h2>
//                         <div className="h-64">
//                             {abandonmentChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.abandonmentRate[timePeriod]), {
//                                     data: abandonmentChartData,
//                                     options: getChartOptions(chartTypeMap.abandonmentRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'abandonmentRate')} filename="abandonment_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">CSAT Score</h2>
//                         <div className="h-64">
//                             {csatChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.csat[timePeriod]), {
//                                     data: csatChartData,
//                                     options: getChartOptions(chartTypeMap.csat[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'csat')} filename="csat_score" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">First Contact Resolution</h2>
//                         <div className="h-64">
//                             {firstContactResolutionChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.firstContactResolution[timePeriod]), {
//                                     data: firstContactResolutionChartData,
//                                     options: getChartOptions(chartTypeMap.firstContactResolution[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'firstContactResolution')} filename="first_contact_resolution" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Chatbot Engagement by Channel</h2>
//                         <div className="h-64">
//                             {chatbotEngagementChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.chatbotEngagement[timePeriod]), {
//                                     data: chatbotEngagementChartData,
//                                     options: getChartOptions(chartTypeMap.chatbotEngagement[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'chatbotEngagement')} filename="chatbot_engagement" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Avg Response Time</h2>
//                         <div className="h-64">
//                             {avgResponseTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.avgResponseTime[timePeriod]), {
//                                     data: avgResponseTimeChartData,
//                                     options: getChartOptions(chartTypeMap.avgResponseTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'avgResponseTime')} filename="avg_response_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Action Success Rate</h2>
//                         <div className="h-64">
//                             {actionSuccessRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.actionSuccessRate[timePeriod]), {
//                                     data: actionSuccessRateChartData,
//                                     options: getChartOptions(chartTypeMap.actionSuccessRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'actionSuccessRate')} filename="action_success_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Sales Generated</h2>
//                         <div className="h-64">
//                             {salesGeneratedChartData.datasets[0].data.some(val => val > 0) ? (
//                                 React.createElement(getChartComponent(chartTypeMap.salesGenerated[timePeriod]), {
//                                     data: salesGeneratedChartData,
//                                     options: getChartOptions(chartTypeMap.salesGenerated[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'salesGenerated')} filename="sales_generated" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Click-Through Rate</h2>
//                         <div className="h-64">
//                             {clickThroughRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.clickThroughRate[timePeriod]), {
//                                     data: clickThroughRateChartData,
//                                     options: getChartOptions(chartTypeMap.clickThroughRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'clickThroughRate')} filename="click_through_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Human Agent Queue Time</h2>
//                         <div className="h-64">
//                             {humanAgentQueueTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.humanAgentQueueTime[timePeriod]), {
//                                     data: humanAgentQueueTimeChartData,
//                                     options: getChartOptions(chartTypeMap.humanAgentQueueTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'humanAgentQueueTime')} filename="human_agent_queue_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Avg Ticket Closure Time</h2>
//                         <div className="h-64">
//                             {avgTicketClosureTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.avgTicketClosureTime[timePeriod]), {
//                                     data: avgTicketClosureTimeChartData,
//                                     options: getChartOptions(chartTypeMap.avgTicketClosureTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'avgTicketClosureTime')} filename="avg_ticket_closure_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Bounce Rate</h2>
//                         <div className="h-64">
//                             {bounceRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.bounceRate[timePeriod]), {
//                                     data: bounceRateChartData,
//                                     options: getChartOptions(chartTypeMap.bounceRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'bounceRate')} filename="bounce_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Hours Saved</h2>
//                         <div className="h-64">
//                             {hoursSavedChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.hoursSaved[timePeriod]), {
//                                     data: hoursSavedChartData,
//                                     options: getChartOptions(chartTypeMap.hoursSaved[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'hoursSaved')} filename="hours_saved" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Cost Saved</h2>
//                         <div className="h-64">
//                             {costSavedChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.costSaved[timePeriod]), {
//                                     data: costSavedChartData,
//                                     options: getChartOptions(chartTypeMap.costSaved[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'costSaved')} filename="cost_saved" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Heatmap of Day and Time</h2>
//                         <div className="h-64">
//                             <div className="grid grid-cols-9 gap-1">
//                                 <div></div>
//                                 {analyticsData[selectedApp].heatmap.hours.map((hour, hIndex) => (
//                                     <div key={hIndex} className="text-center text-xs text-primary">{hour}</div>
//                                 ))}
//                                 {analyticsData[selectedApp].heatmap.values.map((row, rIndex) => (
//                                     <React.Fragment key={rIndex}>
//                                         <div className="text-center text-xs text-primary">{analyticsData[selectedApp].heatmap.days[rIndex]}</div>
//                                         {row.map((value, cIndex) => (
//                                             <div
//                                                 key={cIndex}
//                                                 className="h-8 w-8 rounded"
//                                                 style={{ backgroundColor: `rgba(26, 82, 118, ${value / 200})` }}
//                                                 title={`${value} engagements`}
//                                             />
//                                         ))}
//                                     </React.Fragment>
//                                 ))}
//                             </div>
//                         </div>
//                         {/* <DownloadButton
//                             data={analyticsData[selectedApp].heatmap.values.flat().map((value, index) => ({
//                                 day: analyticsData[selectedApp].heatmap.days[Math.floor(index / 8)],
//                                 hour: analyticsData[selectedApp].heatmap.hours[index % 8],
//                                 value,
//                             }))}
//                             filename="heatmap"
//                         /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Flow Engagement</h2>
//                         <div className="h-64">
//                             {flowEngagementChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.flowEngagement[timePeriod]), {
//                                     data: flowEngagementChartData,
//                                     options: getChartOptions(chartTypeMap.flowEngagement[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'flowEngagement')} filename="flow_engagement" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversation Breakdown</h2>
//                         <div className="h-64">
//                             {conversationBreakdownChartData.datasets[0].data.some(val => val > 0) ? (
//                                 React.createElement(getChartComponent(chartTypeMap.conversationBreakdown[timePeriod]), {
//                                     data: conversationBreakdownChartData,
//                                     options: getChartOptions(chartTypeMap.conversationBreakdown[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton
//                             data={conversationBreakdownChartData.datasets[0].data.map((value, index) => ({
//                                 label: conversationBreakdownChartData.labels[index],
//                                 value,
//                             }))}
//                             filename="conversation_breakdown"
//                         /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Chat Volumes</h2>
//                         <div className="h-64">
//                             {chatVolumeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.chatVolumes[timePeriod]), {
//                                     data: chatVolumeChartData,
//                                     options: getChartOptions(chartTypeMap.chatVolumes[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'chatVolumes')} filename="chat_volumes" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">CSAT Score</h2>
//                         <div className="h-64">
//                             {csatScoreChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.csatScore[timePeriod]), {
//                                     data: csatScoreChartData,
//                                     options: getChartOptions(chartTypeMap.csatScore[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'csatScore')} filename="csat_score" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Feedback Fill Rate</h2>
//                         <div className="h-64">
//                             {feedbackFillRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.feedbackFillRate[timePeriod]), {
//                                     data: feedbackFillRateChartData,
//                                     options: getChartOptions(chartTypeMap.feedbackFillRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'feedbackFillRate')} filename="feedback_fill_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Escalation Rate</h2>
//                         <div className="h-64">
//                             {escalationRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.escalationRate[timePeriod]), {
//                                     data: escalationRateChartData,
//                                     options: getChartOptions(chartTypeMap.escalationRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'escalationRate')} filename="escalation_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Successful Closure Time</h2>
//                         <div className="h-64">
//                             {closureTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.closureTime[timePeriod]), {
//                                     data: closureTimeChartData,
//                                     options: getChartOptions(chartTypeMap.closureTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'closureTime')} filename="closure_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Error Rate</h2>
//                         <div className="h-64">
//                             {errorRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.errors[timePeriod]), {
//                                     data: errorRateChartData,
//                                     options: getChartOptions(chartTypeMap.errors[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'errors')} filename="error_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Abandoned Users</h2>
//                         <div className="h-64">
//                             {abandonedUsersChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.abandonedUsers[timePeriod]), {
//                                     data: abandonedUsersChartData,
//                                     options: getChartOptions(chartTypeMap.abandonedUsers[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'abandonedUsers')} filename="abandoned_users" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Agent Analytics</h2>
//                         <div className="h-64">
//                             {agentAnalyticsChartData.datasets[0].data.some(val => val > 0) ? (
//                                 React.createElement(getChartComponent(chartTypeMap.agentAnalytics[timePeriod]), {
//                                     data: agentAnalyticsChartData,
//                                     options: getChartOptions(chartTypeMap.agentAnalytics[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton
//                             data={agentAnalyticsChartData.datasets[0].data.map((value, index) => ({
//                                 label: agentAnalyticsChartData.labels[index],
//                                 value,
//                             }))}
//                             filename="agent_analytics"
//                         /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">
//                             Acquisitions By {selectedProperty === 'all' ? 'Country' : selectedProperty.charAt(0).toUpperCase() + selectedProperty.slice(1)}
//                         </h2>
//                         <div className="overflow-x-auto">
//                             <table className="min-w-full text-left text-primary">
//                                 <thead>
//                                     <tr>
//                                         <th className="px-4 py-2">Name</th>
//                                         <th className="px-4 py-2">Chats</th>
//                                         <th className="px-4 py-2">Contacts</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {acquisitionsTableData && acquisitionsTableData.length > 0 ? (
//                                         acquisitionsTableData.map((item, index) => (
//                                             <tr key={index} className="border-t">
//                                                 <td className="px-4 py-2">{item.name}</td>
//                                                 <td className="px-4 py-2">{item.chats}</td>
//                                                 <td className="px-4 py-2">{item.contacts}</td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan={3} className="px-4 py-2 text-center">No data available</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                         {/* <DownloadButton data={acquisitionsTableData} filename={`acquisitions_by_${selectedProperty}`} /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Top 3 Queries</h2>
//                         <ul className="list-disc pl-5 text-primary text-left">
//                             {analyticsData[selectedApp].topQueries && analyticsData[selectedApp].topQueries.length > 0 ? (
//                                 analyticsData[selectedApp].topQueries.map((query, index) => (
//                                     <li key={index} className="mb-2">{query}</li>
//                                 ))
//                             ) : (
//                                 <li className="text-primary">No queries available</li>
//                             )}
//                         </ul>
//                         {/* <DownloadButton
//                             data={analyticsData[selectedApp].topQueries.map((query, index) => ({ rank: index + 1, query }))}
//                             filename="top_queries"
//                         /> */}
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Analytics;

// import React, { useState } from 'react';
// import { Bar, Doughnut, Line, Pie, Scatter, Radar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement,
//     RadialLinearScale,
// } from 'chart.js';
// import Layout from '../components/layout';
// import DownloadButton from '../components/downloadButton';
// import Papa from 'papaparse';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, RadialLinearScale);

// function Analytics() {
//     const [selectedApp, setSelectedApp] = useState('whatsapp');
//     const [selectedProperty, setSelectedProperty] = useState('all');
//     const [startDate, setStartDate] = useState('2025-04-01');
//     const [endDate, setEndDate] = useState('2025-04-08');
//     const [timePeriod, setTimePeriod] = useState('daily');

//     // Static data for analytics (mock data for all KPIs, structured for future API)
//     const analyticsData = {
//         whatsapp: {
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 2 },
//                     { date: '2025-04-02', value: 9 },
//                     { date: '2025-04-03', value: 5 },
//                     { date: '2025-04-04', value: 7 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 9 }, { week: 'Week 2', value: 10 }],
//                 monthly: [{ month: '2025-04', value: 10 }, { month: '2025-03', value: 9 }],
//             },
//             conversionRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 6 },
//                     { date: '2025-04-02', value: 8 },
//                     { date: '2025-04-03', value: 7 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 7 }, { week: 'Week 2', value: 8 }],
//                 monthly: [{ month: '2025-04', value: 8 }, { month: '2025-03', value: 7 }],
//             },
//             abandonmentRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 12 },
//                     { date: '2025-04-02', value: 11 },
//                     { date: '2025-04-03', value: 13 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 12 }, { week: 'Week 2', value: 11 }],
//                 monthly: [{ month: '2025-04', value: 12 }, { month: '2025-03', value: 13 }],
//             },
//             csat: {
//                 daily: [
//                     { date: '2025-04-01', value: 4.2 },
//                     { date: '2025-04-02', value: 4.1 },
//                     { date: '2025-04-03', value: 4.3 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 4.2 }, { week: 'Week 2', value: 4.1 }],
//                 monthly: [{ month: '2025-04', value: 4.2 }, { month: '2025-03', value: 4.0 }],
//             },
//             firstContactResolution: {
//                 daily: [
//                     { date: '2025-04-01', value: 700 },
//                     { date: '2025-04-02', value: 710 },
//                     { date: '2025-04-03', value: 690 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 705 }, { week: 'Week 2', value: 700 }],
//                 monthly: [{ month: '2025-04', value: 700 }, { month: '2025-03', value: 690 }],
//             },
//             chatbotEngagement: {
//                 daily: [
//                     { date: '2025-04-01', whatsapp: 1000, website: 800, instagram: 600 },
//                     { date: '2025-04-02', whatsapp: 990, website: 810, instagram: 590 },
//                 ],
//                 weekly: [
//                     { week: 'Week 1', whatsapp: 990, website: 810, instagram: 590 },
//                     { week: 'Week 2', whatsapp: 1000, website: 800, instagram: 600 },
//                 ],
//                 monthly: [
//                     { month: '2025-04', whatsapp: 1000, website: 800, instagram: 600 },
//                     { month: '2025-03', whatsapp: 980, website: 790, instagram: 580 },
//                 ],
//             },
//             avgResponseTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 1.8 },
//                     { date: '2025-04-02', value: 1.7 },
//                     { date: '2025-04-03', value: 1.9 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 1.8 }, { week: 'Week 2', value: 1.7 }],
//                 monthly: [{ month: '2025-04', value: 1.8 }, { month: '2025-03', value: 1.9 }],
//             },
//             actionSuccessRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 85 },
//                     { date: '2025-04-02', value: 86 },
//                     { date: '2025-04-03', value: 84 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 85 }, { week: 'Week 2', value: 86 }],
//                 monthly: [{ month: '2025-04', value: 85 }, { month: '2025-03', value: 84 }],
//             },
//             salesGenerated: {
//                 daily: [
//                     { date: '2025-04-01', cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
//                     { date: '2025-04-02', cartAdditions: 4900, productRecommendations: 3100, dealDiscovery: 1900 },
//                 ],
//                 weekly: [
//                     { week: 'Week 1', cartAdditions: 4900, productRecommendations: 3100, dealDiscovery: 1900 },
//                     { week: 'Week 2', cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
//                 ],
//                 monthly: [
//                     { month: '2025-04', cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
//                     { month: '2025-03', cartAdditions: 4800, productRecommendations: 2900, dealDiscovery: 1800 },
//                 ],
//             },
//             clickThroughRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 25 },
//                     { date: '2025-04-02', value: 24 },
//                     { date: '2025-04-03', value: 26 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 25 }, { week: 'Week 2', value: 24 }],
//                 monthly: [{ month: '2025-04', value: 25 }, { month: '2025-03', value: 23 }],
//             },
//             humanAgentQueueTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 5 },
//                     { date: '2025-04-02', value: 4.8 },
//                     { date: '2025-04-03', value: 5.2 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 5 }, { week: 'Week 2', value: 4.9 }],
//                 monthly: [{ month: '2025-04', value: 5 }, { month: '2025-03', value: 5.1 }],
//             },
//             avgTicketClosureTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 24 },
//                     { date: '2025-04-02', value: 23 },
//                     { date: '2025-04-03', value: 25 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 24 }, { week: 'Week 2', value: 23 }],
//                 monthly: [{ month: '2025-04', value: 24 }, { month: '2025-03', value: 25 }],
//             },
//             bounceRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 15 },
//                     { date: '2025-04-02', value: 14 },
//                     { date: '2025-04-03', value: 16 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 15 }, { week: 'Week 2', value: 14 }],
//                 monthly: [{ month: '2025-04', value: 15 }, { month: '2025-03', value: 16 }],
//             },
//             hoursSaved: {
//                 daily: [
//                     { date: '2025-04-01', value: 120 },
//                     { date: '2025-04-02', value: 118 },
//                     { date: '2025-04-03', value: 122 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 120 }, { week: 'Week 2', value: 119 }],
//                 monthly: [{ month: '2025-04', value: 120 }, { month: '2025-03', value: 118 }],
//             },
//             costSaved: {
//                 daily: [
//                     { date: '2025-04-01', value: 2400 },
//                     { date: '2025-04-02', value: 2350 },
//                     { date: '2025-04-03', value: 2450 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2400 }, { week: 'Week 2', value: 2375 }],
//                 monthly: [{ month: '2025-04', value: 2400 }, { month: '2025-03', value: 2300 }],
//             },
//             heatmap: {
//                 days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
//                 hours: ['12AM', '3AM', '6AM', '9AM', '12PM', '3PM', '6PM', '9PM'],
//                 values: [
//                     [50, 60, 70, 80, 90, 100, 110, 120],
//                     [60, 70, 80, 90, 100, 110, 120, 130],
//                     [70, 80, 90, 100, 110, 120, 130, 140],
//                     [80, 90, 100, 110, 120, 130, 140, 150],
//                     [90, 100, 110, 120, 130, 140, 150, 160],
//                     [100, 110, 120, 130, 140, 150, 160, 170],
//                     [110, 120, 130, 140, 150, 160, 170, 180],
//                 ],
//             },
//             flowEngagement: {
//                 daily: [
//                     { date: '2025-04-01', actionBlock: 'Welcome', count: 1000, exit: 20 },
//                     { date: '2025-04-01', actionBlock: 'Product Inquiry', count: 800, exit: 30 },
//                 ],
//                 weekly: [
//                     { week: 'Week 1', actionBlock: 'Welcome', count: 990, exit: 21 },
//                     { week: 'Week 1', actionBlock: 'Product Inquiry', count: 790, exit: 31 },
//                 ],
//                 monthly: [
//                     { month: '2025-04', actionBlock: 'Welcome', count: 1000, exit: 20 },
//                     { month: '2025-04', actionBlock: 'Product Inquiry', count: 800, exit: 30 },
//                 ],
//             },
//             upRatedConversations: {
//                 daily: [
//                     { date: '2025-04-01', value: 600 },
//                     { date: '2025-04-02', value: 610 },
//                     { date: '2025-04-03', value: 590 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 605 }, { week: 'Week 2', value: 600 }],
//                 monthly: [{ month: '2025-04', value: 600 }, { month: '2025-03', value: 590 }],
//             },
//             downRatedConversations: {
//                 daily: [
//                     { date: '2025-04-01', value: 50 },
//                     { date: '2025-04-02', value: 48 },
//                     { date: '2025-04-03', value: 52 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 50 }, { week: 'Week 2', value: 49 }],
//                 monthly: [{ month: '2025-04', value: 50 }, { month: '2025-03', value: 51 }],
//             },
//             ticketsCreated: {
//                 daily: [
//                     { date: '2025-04-01', value: 200 },
//                     { date: '2025-04-02', value: 195 },
//                     { date: '2025-04-03', value: 205 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 200 }, { week: 'Week 2', value: 198 }],
//                 monthly: [{ month: '2025-04', value: 200 }, { month: '2025-03', value: 195 }],
//             },
//             chatVolumes: {
//                 daily: [
//                     { date: '2025-04-01', value: 2156 },
//                     { date: '2025-04-02', value: 2100 },
//                     { date: '2025-04-03', value: 2200 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2128 }, { week: 'Week 2', value: 2150 }],
//                 monthly: [{ month: '2025-04', value: 2156 }, { month: '2025-03', value: 2100 }],
//             },
//             topQueries: ['Billing Issues', 'Product Queries', 'Technical Support'],
//             csatScore: {
//                 daily: [
//                     { date: '2025-04-01', value: 4.2 },
//                     { date: '2025-04-02', value: 4.1 },
//                     { date: '2025-04-03', value: 4.3 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 4.2 }, { week: 'Week 2', value: 4.1 }],
//                 monthly: [{ month: '2025-04', value: 4.2 }, { month: '2025-03', value: 4.0 }],
//             },
//             feedbackFillRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 85 },
//                     { date: '2025-04-02', value: 84 },
//                     { date: '2025-04-03', value: 86 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 85 }, { week: 'Week 2', value: 84 }],
//                 monthly: [{ month: '2025-04', value: 85 }, { month: '2025-03', value: 83 }],
//             },
//             escalationRate: {
//                 daily: [
//                     { date: '2025-04-01', value: 15 },
//                     { date: '2025-04-02', value: 14 },
//                     { date: '2025-04-03', value: 16 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 15 }, { week: 'Week 2', value: 14 }],
//                 monthly: [{ month: '2025-04', value: 15 }, { month: '2025-03', value: 13 }],
//             },
//             closureTime: {
//                 daily: [
//                     { date: '2025-04-01', value: 2.5 },
//                     { date: '2025-04-02', value: 2.4 },
//                     { date: '2025-04-03', value: 2.6 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2.5 }, { week: 'Week 2', value: 2.4 }],
//                 monthly: [{ month: '2025-04', value: 2.5 }, { month: '2025-03', value: 2.3 }],
//             },
//             errors: {
//                 daily: [
//                     { date: '2025-04-01', value: 2 },
//                     { date: '2025-04-02', value: 1.8 },
//                     { date: '2025-04-03', value: 2.2 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 2 }, { week: 'Week 2', value: 1.9 }],
//                 monthly: [{ month: '2025-04', value: 2 }, { month: '2025-03', value: 1.8 }],
//             },
//             abandonedUsers: {
//                 daily: [
//                     { date: '2025-04-01', value: 12 },
//                     { date: '2025-04-02', value: 11 },
//                     { date: '2025-04-03', value: 13 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 12 }, { week: 'Week 2', value: 11 }],
//                 monthly: [{ month: '2025-04', value: 12 }, { month: '2025-03', value: 13 }],
//             },
//             agentAnalytics: {
//                 currentlyServing: {
//                     daily: [
//                         { date: '2025-04-01', value: 10 },
//                         { date: '2025-04-02', value: 12 },
//                         { date: '2025-04-03', value: 11 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 11 }, { week: 'Week 2', value: 12 }],
//                     monthly: [{ month: '2025-04', value: 11 }, { month: '2025-03', value: 10 }],
//                 },
//                 totalServed: {
//                     daily: [
//                         { date: '2025-04-01', value: 500 },
//                         { date: '2025-04-02', value: 510 },
//                         { date: '2025-04-03', value: 490 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 505 }, { week: 'Week 2', value: 500 }],
//                     monthly: [{ month: '2025-04', value: 500 }, { month: '2025-03', value: 490 }],
//                 },
//                 conversationsHandled: {
//                     daily: [
//                         { date: '2025-04-01', value: 50 },
//                         { date: '2025-04-02', value: 52 },
//                         { date: '2025-04-03', value: 48 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 50 }, { week: 'Week 2', value: 51 }],
//                     monthly: [{ month: '2025-04', value: 50 }, { month: '2025-03', value: 49 }],
//                 },
//                 conversationTransfers: {
//                     daily: [
//                         { date: '2025-04-01', value: 20 },
//                         { date: '2025-04-02', value: 18 },
//                         { date: '2025-04-03', value: 22 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 20 }, { week: 'Week 2', value: 19 }],
//                     monthly: [{ month: '2025-04', value: 20 }, { month: '2025-03', value: 21 }],
//                 },
//                 timeToFirstResponse: {
//                     daily: [
//                         { date: '2025-04-01', value: 0.5 },
//                         { date: '2025-04-02', value: 0.4 },
//                         { date: '2025-04-03', value: 0.6 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 0.5 }, { week: 'Week 2', value: 0.4 }],
//                     monthly: [{ month: '2025-04', value: 0.5 }, { month: '2025-03', value: 0.6 }],
//                 },
//                 usualTimeToResponse: {
//                     daily: [
//                         { date: '2025-04-01', value: 0.75 },
//                         { date: '2025-04-02', value: 0.7 },
//                         { date: '2025-04-03', value: 0.8 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 0.75 }, { week: 'Week 2', value: 0.7 }],
//                     monthly: [{ month: '2025-04', value: 0.75 }, { month: '2025-03', value: 0.8 }],
//                 },
//                 conversationDuration: {
//                     daily: [
//                         { date: '2025-04-01', value: 10 },
//                         { date: '2025-04-02', value: 9.5 },
//                         { date: '2025-04-03', value: 10.5 },
//                     ],
//                     weekly: [{ week: 'Week 1', value: 10 }, { week: 'Week 2', value: 9.8 }],
//                     monthly: [{ month: '2025-04', value: 10 }, { month: '2025-03', value: 9.7 }],
//                 },
//             },
//             acquisitions: {
//                 country: [
//                     { name: 'USA', chats: 500, contacts: 300 },
//                     { name: 'India', chats: 400, contacts: 250 },
//                 ],
//                 city: [
//                     { name: 'New York', chats: 200, contacts: 120 },
//                     { name: 'Mumbai', chats: 150, contacts: 90 },
//                 ],
//                 state: [
//                     { name: 'CA', chats: 150, contacts: 90 },
//                     { name: 'MH', chats: 100, contacts: 60 },
//                 ],
//                 webpage: [
//                     { name: 'Homepage', chats: 400, contacts: 250 },
//                     { name: 'Product Page', chats: 300, contacts: 180 },
//                 ],
//                 referral: [
//                     { name: 'Google', chats: 300, contacts: 180 },
//                     { name: 'Facebook', chats: 200, contacts: 120 },
//                 ],
//                 utm_source: [
//                     { name: 'email', chats: 100, contacts: 60 },
//                     { name: 'social', chats: 150, contacts: 90 },
//                 ],
//                 utm_medium: [
//                     { name: 'cpc', chats: 200, contacts: 120 },
//                     { name: 'banner', chats: 100, contacts: 60 },
//                 ],
//                 utm_campaign: [
//                     { name: 'spring_sale', chats: 150, contacts: 90 },
//                     { name: 'summer_promo', chats: 100, contacts: 60 },
//                 ],
//             },
//         },
//         telegram: {
//             // Similar structure with different values (mock data)
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 7 },
//                     { date: '2025-04-02', value: 9 },
//                     { date: '2025-04-03', value: 8 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 8 }, { week: 'Week 2', value: 9 }],
//                 monthly: [{ month: '2025-04', value: 9 }, { month: '2025-03', value: 8 }],
//             },
//             // ... other KPIs with similar structure
//         },
//         infobip: {
//             // Similar structure with different values (mock data)
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 9 },
//                     { date: '2025-04-02', value: 10 },
//                     { date: '2025-04-03', value: 8 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 9 }, { week: 'Week 2', value: 10 }],
//                 monthly: [{ month: '2025-04', value: 10 }, { month: '2025-03', value: 9 }],
//             },
//             // ... other KPIs with similar structure
//         },
//         wati: {
//             // Similar structure with different values (mock data)
//             engagement: {
//                 daily: [
//                     { date: '2025-04-01', value: 6 },
//                     { date: '2025-04-02', value: 8 },
//                     { date: '2025-04-03', value: 7 },
//                 ],
//                 weekly: [{ week: 'Week 1', value: 7 }, { week: 'Week 2', value: 8 }],
//                 monthly: [{ month: '2025-04', value: 8 }, { month: '2025-03', value: 7 }],
//             },
//             // ... other KPIs with similar structure
//         },
//     };

//     // Filter data based on date range
//     const getFilteredData = (data, key) => {
//         const filtered = data[key][timePeriod]?.filter(item => {
//             const itemDate = new Date(item.date || item.week || item.month);
//             const start = new Date(startDate);
//             const end = new Date(endDate);
//             return itemDate >= start && itemDate <= end;
//         });
//         return filtered;
//     };

//     // // Chart type mapping based on time period
//     // const chartTypeMap = {
//     //     engagement: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     conversionRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     abandonmentRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     csat: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     firstContactResolution: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     chatbotEngagement: { daily: 'Bar', weekly: 'Bar', monthly: 'Pie' },
//     //     avgResponseTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     actionSuccessRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     salesGenerated: { daily: 'Pie', weekly: 'Pie', monthly: 'Pie' },
//     //     clickThroughRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     humanAgentQueueTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     avgTicketClosureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     bounceRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     hoursSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     costSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     flowEngagement: { daily: 'Bar', weekly: 'Bar', monthly: 'Pie' },
//     //     conversationBreakdown: { daily: 'Doughnut', weekly: 'Doughnut', monthly: 'Doughnut' },
//     //     chatVolumes: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     csatScore: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     feedbackFillRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     escalationRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     closureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     errors: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     abandonedUsers: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//     //     agentAnalytics: { daily: 'Radar', weekly: 'Radar', monthly: 'Radar' },
//     // };

//     const chartTypeMap = {
//         engagement: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for monthly to show magnitude
//         conversionRate: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for monthly proportions
//         abandonmentRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for simple monthly proportion
//         csat: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea to emphasize CSAT scores
//         firstContactResolution: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for monthly total
//         chatbotEngagement: { daily: 'Bubble', weekly: 'Bar', monthly: 'Doughnut' }, // Bubble for multi-channel daily data
//         avgResponseTime: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for response time magnitude
//         actionSuccessRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for success rate proportion
//         salesGenerated: { daily: 'Doughnut', weekly: 'Doughnut', monthly: 'Doughnut' }, // Doughnut for consistent proportions
//         clickThroughRate: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for CTR magnitude
//         humanAgentQueueTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for queue time proportion
//         avgTicketClosureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for closure time proportion
//         bounceRate: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for bounce rate magnitude
//         hoursSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for total hours saved
//         costSaved: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for total cost saved
//         flowEngagement: { daily: 'Bar', weekly: 'Bar', monthly: 'Doughnut' }, // Doughnut for action block proportions
//         conversationBreakdown: { daily: 'Doughnut', weekly: 'Doughnut', monthly: 'Doughnut' }, // Doughnut for proportions
//         chatVolumes: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for volume magnitude
//         csatScore: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for CSAT score emphasis
//         feedbackFillRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for feedback rate proportion
//         escalationRate: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for escalation proportion
//         closureTime: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for closure time proportion
//         errors: { daily: 'Line', weekly: 'Bar', monthly: 'PolarArea' }, // PolarArea for error rate magnitude
//         abandonedUsers: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }, // Pie for abandoned users proportion
//         agentAnalytics: { daily: 'Radar', weekly: 'Radar', monthly: 'Radar' }, // Radar for multi-metric comparison
//         // New Mixed chart for comparing related metrics
//         engagementVsConversion: { daily: 'Mixed', weekly: 'Mixed', monthly: 'Scatter' }, // Added for correlation analysis
//     };

//     // Chart data configurations
//     const engagementChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'engagement').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Engagement %',
//                 data: getFilteredData(analyticsData[selectedApp], 'engagement').map(item => item.value),
//                 borderColor: '#1A5276',
//                 backgroundColor: timePeriod === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//                 fill: chartTypeMap.engagement[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const conversionChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'conversionRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Conversion Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'conversionRate').map(item => item.value),
//                 borderColor: '#F87171',
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#34D399', '#1A5276'] : '#F87171',
//                 fill: chartTypeMap.conversionRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const abandonmentChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'abandonmentRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Abandonment Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'abandonmentRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#FBBF24', '#34D399', '#1A5276'] : '#FBBF24',
//                 borderColor: '#FBBF24',
//                 fill: chartTypeMap.abandonmentRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const csatChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'csat').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'CSAT Score',
//                 data: getFilteredData(analyticsData[selectedApp], 'csat').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#FBBF24', '#1A5276'] : '#34D399',
//                 borderColor: '#34D399',
//                 fill: chartTypeMap.csat[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const firstContactResolutionChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'firstContactResolution').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'First Contact Resolution',
//                 data: getFilteredData(analyticsData[selectedApp], 'firstContactResolution').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#FBBF24', '#34D399'] : '#48BBF9',
//                 borderColor: '#48BBF9',
//                 fill: chartTypeMap.firstContactResolution[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const chatbotEngagementChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'WhatsApp',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.whatsapp),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#48BBF9', '#8B5CF6'] : '#34D399',
//             },
//             {
//                 label: 'Website',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.website),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#34D399', '#8B5CF6'] : '#48BBF9',
//             },
//             {
//                 label: 'Instagram',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatbotEngagement').map(item => item.instagram),
//                 backgroundColor: timePeriod === 'monthly' ? ['#8B5CF6', '#34D399', '#48BBF9'] : '#8B5CF6',
//             },
//         ],
//     };

//     const avgResponseTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'avgResponseTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Avg Response Time (s)',
//                 data: getFilteredData(analyticsData[selectedApp], 'avgResponseTime').map(item => item.value),
//                 borderColor: '#EC4899',
//                 backgroundColor: timePeriod === 'monthly' ? ['#EC4899', '#FBBF24', '#34D399'] : '#EC4899',
//                 fill: chartTypeMap.avgResponseTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const actionSuccessRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'actionSuccessRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Action Success Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'actionSuccessRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//                 borderColor: '#1A5276',
//                 fill: chartTypeMap.actionSuccessRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const salesGeneratedChartData = {
//         labels: ['Cart Additions', 'Product Recommendations', 'Deal Discovery'],
//         datasets: [
//             {
//                 data: [
//                     getFilteredData(analyticsData[selectedApp], 'salesGenerated')?.reduce((sum, item) => sum + item.cartAdditions, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'salesGenerated')?.reduce((sum, item) => sum + item.productRecommendations, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'salesGenerated')?.reduce((sum, item) => sum + item.dealDiscovery, 0) || 0,
//                 ],
//                 backgroundColor: ['#1A5276', '#F87171', '#34D399'],
//             },
//         ],
//     };

//     const clickThroughRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'clickThroughRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Click-Through Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'clickThroughRate').map(item => item.value),
//                 borderColor: '#FBBF24',
//                 backgroundColor: timePeriod === 'monthly' ? ['#FBBF24', '#34D399', '#1A5276'] : '#FBBF24',
//                 fill: chartTypeMap.clickThroughRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const humanAgentQueueTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'humanAgentQueueTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Human Agent Queue Time (m)',
//                 data: getFilteredData(analyticsData[selectedApp], 'humanAgentQueueTime').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#8B5CF6', '#FBBF24', '#34D399'] : '#8B5CF6',
//                 borderColor: '#8B5CF6',
//                 fill: chartTypeMap.humanAgentQueueTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const avgTicketClosureTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'avgTicketClosureTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Avg Ticket Closure Time (h)',
//                 data: getFilteredData(analyticsData[selectedApp], 'avgTicketClosureTime').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#EC4899', '#FBBF24', '#34D399'] : '#EC4899',
//                 borderColor: '#EC4899',
//                 fill: chartTypeMap.avgTicketClosureTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const bounceRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'bounceRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Bounce Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'bounceRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#34D399', '#1A5276'] : '#F87171',
//                 borderColor: '#F87171',
//                 fill: chartTypeMap.bounceRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const hoursSavedChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'hoursSaved').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Hours Saved',
//                 data: getFilteredData(analyticsData[selectedApp], 'hoursSaved').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#FBBF24', '#1A5276'] : '#34D399',
//                 borderColor: '#34D399',
//                 fill: chartTypeMap.hoursSaved[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const costSavedChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'costSaved').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Cost Saved ($)',
//                 data: getFilteredData(analyticsData[selectedApp], 'costSaved').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#FBBF24', '#34D399'] : '#48BBF9',
//                 borderColor: '#48BBF9',
//                 fill: chartTypeMap.costSaved[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const heatmapChartData = {
//         labels: analyticsData[selectedApp].heatmap.days,
//         datasets: analyticsData[selectedApp].heatmap.hours.map((hour, index) => ({
//             label: hour,
//             data: analyticsData[selectedApp].heatmap.values.map(row => row[index]),
//             backgroundColor: '#1A5276',
//         })),
//     };

//     const flowEngagementChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'flowEngagement').map(item => item.actionBlock),
//         datasets: [
//             {
//                 label: 'Count',
//                 data: getFilteredData(analyticsData[selectedApp], 'flowEngagement').map(item => item.count),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#F87171', '#34D399'] : '#48BBF9',
//             },
//             {
//                 label: 'Exit %',
//                 data: getFilteredData(analyticsData[selectedApp], 'flowEngagement').map(item => item.exit),
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#48BBF9', '#34D399'] : '#F87171',
//             },
//         ],
//     };

//     const conversationBreakdownChartData = {
//         labels: ['Up-Rated Bot', 'Down-Rated Bot', 'Tickets Created', 'Human Involved'],
//         datasets: [
//             {
//                 data: [
//                     getFilteredData(analyticsData[selectedApp], 'upRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'downRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp], 'ticketsCreated')?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     (getFilteredData(analyticsData[selectedApp], 'chatbotEngagement')?.reduce((sum, item) => sum + item.whatsapp + item.website + item.instagram, 0) || 0) -
//                     (getFilteredData(analyticsData[selectedApp], 'upRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0) -
//                     (getFilteredData(analyticsData[selectedApp], 'downRatedConversations')?.reduce((sum, item) => sum + item.value, 0) || 0) -
//                     (getFilteredData(analyticsData[selectedApp], 'ticketsCreated')?.reduce((sum, item) => sum + item.value, 0) || 0),
//                 ],
//                 backgroundColor: ['#1A5276', '#F87171', '#48BBF9', '#A9A9A9'],
//             },
//         ],
//     };

//     const chatVolumeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'chatVolumes').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Chat Volumes',
//                 data: getFilteredData(analyticsData[selectedApp], 'chatVolumes').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#48BBF9', '#FBBF24', '#34D399'] : '#48BBF9',
//                 borderColor: '#48BBF9',
//                 fill: chartTypeMap.chatVolumes[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const csatScoreChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'csatScore').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'CSAT Score',
//                 data: getFilteredData(analyticsData[selectedApp], 'csatScore').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#34D399', '#FBBF24', '#1A5276'] : '#34D399',
//                 borderColor: '#34D399',
//                 fill: chartTypeMap.csatScore[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const feedbackFillRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'feedbackFillRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Feedback Fill Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'feedbackFillRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#FBBF24', '#34D399', '#1A5276'] : '#FBBF24',
//                 borderColor: '#FBBF24',
//                 fill: chartTypeMap.feedbackFillRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const escalationRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'escalationRate').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Escalation Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'escalationRate').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#8B5CF6', '#FBBF24', '#34D399'] : '#8B5CF6',
//                 borderColor: '#8B5CF6',
//                 fill: chartTypeMap.escalationRate[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const closureTimeChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'closureTime').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Closure Time (m)',
//                 data: getFilteredData(analyticsData[selectedApp], 'closureTime').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#EC4899', '#FBBF24', '#34D399'] : '#EC4899',
//                 borderColor: '#EC4899',
//                 fill: chartTypeMap.closureTime[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const errorRateChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'errors').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Error Rate %',
//                 data: getFilteredData(analyticsData[selectedApp], 'errors').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#F87171', '#34D399', '#1A5276'] : '#F87171',
//                 borderColor: '#F87171',
//                 fill: chartTypeMap.errors[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const abandonedUsersChartData = {
//         labels: getFilteredData(analyticsData[selectedApp], 'abandonedUsers').map(item => item.date || item.week || item.month),
//         datasets: [
//             {
//                 label: 'Abandoned Users %',
//                 data: getFilteredData(analyticsData[selectedApp], 'abandonedUsers').map(item => item.value),
//                 backgroundColor: timePeriod === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//                 borderColor: '#1A5276',
//                 fill: chartTypeMap.abandonedUsers[timePeriod] === 'Line',
//             },
//         ],
//     };

//     const agentAnalyticsChartData = {
//         labels: ['Currently Serving', 'Total Served', 'Conversations Handled', 'Conversation Transfers', 'Time to First Response', 'Usual Time to Response', 'Conversation Duration'],
//         datasets: [
//             {
//                 label: 'Agent Analytics',
//                 data: [
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.currentlyServing, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.totalServed, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.conversationsHandled, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.conversationTransfers, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.timeToFirstResponse, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.usualTimeToResponse, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                     getFilteredData(analyticsData[selectedApp].agentAnalytics.conversationDuration, timePeriod)?.reduce((sum, item) => sum + item.value, 0) || 0,
//                 ],
//                 backgroundColor: 'rgba(139, 92, 246, 0.2)',
//                 borderColor: '#8B5CF6',
//                 fill: true,
//             },
//         ],
//     };

//     const acquisitionsTableData = analyticsData[selectedApp].acquisitions[selectedProperty === 'all' ? 'country' : selectedProperty];

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: function (context) {
//                         return `${context.dataset.label}: ${context.parsed.y || context.parsed}`;
//                     },
//                 },
//             },
//         },
//         scales: {
//             y: {
//                 beginAtZero: true,
//                 title: {
//                     display: true,
//                     text: 'Value',
//                 },
//             },
//             x: {
//                 title: {
//                     display: true,
//                     text: timePeriod.charAt(0).toUpperCase() + timePeriod.slice(1),
//                 },
//             },
//         },
//     };

//     const pieChartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: function (context) {
//                         return `${context.label}: ${context.parsed}`;
//                     },
//                 },
//             },
//         },
//     };

//     const radarChartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//         },
//         scales: {
//             r: {
//                 beginAtZero: true,
//                 suggestedMin: 0,
//                 suggestedMax: 1000,
//             },
//         },
//     };

//     // Function to get the appropriate chart component
//     const getChartComponent = (chartType) => {
//         switch (chartType) {
//             case 'Line':
//                 return Line;
//             case 'Bar':
//                 return Bar;
//             case 'Pie':
//                 return Pie;
//             case 'Doughnut':
//                 return Doughnut;
//             case 'Radar':
//                 return Radar;
//             default:
//                 return Bar;
//         }
//     };

//     // Function to get chart options based on chart type
//     const getChartOptions = (chartType) => {
//         if (chartType === 'Pie' || chartType === 'Doughnut') {
//             return pieChartOptions;
//         } else if (chartType === 'Radar') {
//             return radarChartOptions;
//         }
//         return chartOptions;
//     };

//     const apps = [
//         { value: 'whatsapp', label: 'WhatsApp' },
//         { value: 'telegram', label: 'Telegram' },
//         { value: 'infobip', label: 'Infobip' },
//         { value: 'wati', label: 'Wati' },
//     ];

//     const properties = [
//         { value: 'all', label: 'All' },
//         { value: 'country', label: 'Country' },
//         { value: 'city', label: 'City' },
//         { value: 'state', label: 'State' },
//         { value: 'webpage', label: 'Webpage' },
//         { value: 'referral', label: 'Referral' },
//         { value: 'utm_source', label: 'UTM Source' },
//         { value: 'utm_medium', label: 'UTM Medium' },
//         { value: 'utm_campaign', label: 'UTM Campaign' },
//     ];

//     // Aggregate all analytics data for DownloadButton
//     const allAnalyticsData = (() => {
//         const allData = [];

//         // Define all metrics to include
//         const metrics = [
//             { key: 'engagement', label: 'Engagement %' },
//             { key: 'conversionRate', label: 'Conversion Rate %' },
//             { key: 'abandonmentRate', label: 'Abandonment Rate %' },
//             { key: 'csat', label: 'CSAT Score' },
//             { key: 'firstContactResolution', label: 'First Contact Resolution' },
//             { key: 'chatbotEngagement', label: 'Chatbot Engagement' },
//             { key: 'avgResponseTime', label: 'Avg Response Time (s)' },
//             { key: 'actionSuccessRate', label: 'Action Success Rate %' },
//             { key: 'salesGenerated', label: 'Sales Generated' },
//             { key: 'clickThroughRate', label: 'Click-Through Rate %' },
//             { key: 'humanAgentQueueTime', label: 'Human Agent Queue Time (m)' },
//             { key: 'avgTicketClosureTime', label: 'Avg Ticket Closure Time (h)' },
//             { key: 'bounceRate', label: 'Bounce Rate %' },
//             { key: 'hoursSaved', label: 'Hours Saved' },
//             { key: 'costSaved', label: 'Cost Saved ($)' },
//             { key: 'flowEngagement', label: 'Flow Engagement' },
//             { key: 'chatVolumes', label: 'Chat Volumes' },
//             { key: 'csatScore', label: 'CSAT Score' },
//             { key: 'feedbackFillRate', label: 'Feedback Fill Rate %' },
//             { key: 'escalationRate', label: 'Escalation Rate %' },
//             { key: 'closureTime', label: 'Closure Time (m)' },
//             { key: 'errors', label: 'Error Rate %' },
//             { key: 'abandonedUsers', label: 'Abandoned Users %' },
//         ];

//         // Add chart data
//         metrics.forEach(({ key, label }) => {
//             const filteredData = getFilteredData(analyticsData[selectedApp], key);
//             filteredData.forEach(item => {
//                 allData.push({
//                     Metric: label,
//                     TimePeriod: timePeriod,
//                     Date: item.date || item.week || item.month || '',
//                     ...item, // Spread item to include all properties (e.g., value, whatsapp, website, instagram)
//                 });
//             });
//         });

//         // Add conversation breakdown
//         conversationBreakdownChartData.labels.forEach((label, index) => {
//             allData.push({
//                 Metric: 'Conversation Breakdown',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Label: label,
//                 Value: conversationBreakdownChartData.datasets[0].data[index],
//             });
//         });

//         // Add agent analytics
//         agentAnalyticsChartData.labels.forEach((label, index) => {
//             allData.push({
//                 Metric: 'Agent Analytics',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Label: label,
//                 Value: agentAnalyticsChartData.datasets[0].data[index],
//             });
//         });

//         // Add acquisitions
//         acquisitionsTableData.forEach(item => {
//             allData.push({
//                 Metric: `Acquisitions by ${selectedProperty === 'all' ? 'Country' : selectedProperty}`,
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Name: item.name,
//                 Chats: item.chats,
//                 Contacts: item.contacts,
//             });
//         });

//         // Add top queries
//         analyticsData[selectedApp].topQueries.forEach((query, index) => {
//             allData.push({
//                 Metric: 'Top Queries',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Rank: index + 1,
//                 Query: query,
//             });
//         });

//         // Add heatmap data
//         analyticsData[selectedApp].heatmap.values.flat().forEach((value, index) => {
//             allData.push({
//                 Metric: 'Heatmap',
//                 TimePeriod: timePeriod,
//                 Date: '',
//                 Day: analyticsData[selectedApp].heatmap.days[Math.floor(index / 8)],
//                 Hour: analyticsData[selectedApp].heatmap.hours[index % 8],
//                 Engagements: value,
//             });
//         });

//         return allData;
//     })();

//     return (
//         <Layout>
//             <div className="p-6 bg-gray-100 min-h-screen">
//                 {/* <h1 className="text-2xl font-semibold text-primary mb-6">Chatbot Analytics</h1> */}

//                 {/* Download Button for All Analytics */}
//                 <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
//                     <h2 className="text-xl font-semibold text-primary">Download Analytics Data</h2>
//                     <DownloadButton
//                         data={allAnalyticsData}
//                         filename={`analytics_${selectedApp}_${timePeriod}`}
//                     />
//                 </div>

//                 {/* Filters */}
//                 <div className="bg-white p-4 rounded-lg shadow-md mb-6 flex flex-row flex-wrap gap-4 items-center w-full">
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">App</label>
//                         <select
//                             value={selectedApp}
//                             onChange={(e) => setSelectedApp(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         >
//                             {apps.map(app => (
//                                 <option key={app.value} value={app.value}>{app.label}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">Property</label>
//                         <select
//                             value={selectedProperty}
//                             onChange={(e) => setSelectedProperty(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         >
//                             {properties.map(prop => (
//                                 <option key={prop.value} value={prop.value}>{prop.label}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">Start Date</label>
//                         <input
//                             type="date"
//                             value={startDate}
//                             onChange={(e) => setStartDate(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">End Date</label>
//                         <input
//                             type="date"
//                             value={endDate}
//                             onChange={(e) => setEndDate(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                     </div>
//                     <div className="flex-1 min-w-[200px]">
//                         <label className="text-primary font-medium mb-2 block">Time Period</label>
//                         <select
//                             value={timePeriod}
//                             onChange={(e) => setTimePeriod(e.target.value)}
//                             className="w-full p-2 border border-primary rounded-md text-primary focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         >
//                             <option value="daily">Daily</option>
//                             <option value="weekly">Weekly</option>
//                             <option value="monthly">Monthly</option>
//                         </select>
//                     </div>
//                 </div>

//                 {/* Analytics Metrics */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Engagement %</h2>
//                         <div className="h-64">
//                             {engagementChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.engagement[timePeriod]), {
//                                     data: engagementChartData,
//                                     options: getChartOptions(chartTypeMap.engagement[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'engagement')} filename="engagement" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversion Rate</h2>
//                         <div className="h-64">
//                             {conversionChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.conversionRate[timePeriod]), {
//                                     data: conversionChartData,
//                                     options: getChartOptions(chartTypeMap.conversionRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'conversionRate')} filename="conversion_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Abandonment Rate</h2>
//                         <div className="h-64">
//                             {abandonmentChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.abandonmentRate[timePeriod]), {
//                                     data: abandonmentChartData,
//                                     options: getChartOptions(chartTypeMap.abandonmentRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'abandonmentRate')} filename="abandonment_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">CSAT Score</h2>
//                         <div className="h-64">
//                             {csatChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.csat[timePeriod]), {
//                                     data: csatChartData,
//                                     options: getChartOptions(chartTypeMap.csat[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'csat')} filename="csat_score" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">First Contact Resolution</h2>
//                         <div className="h-64">
//                             {firstContactResolutionChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.firstContactResolution[timePeriod]), {
//                                     data: firstContactResolutionChartData,
//                                     options: getChartOptions(chartTypeMap.firstContactResolution[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'firstContactResolution')} filename="first_contact_resolution" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Chatbot Engagement by Channel</h2>
//                         <div className="h-64">
//                             {chatbotEngagementChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.chatbotEngagement[timePeriod]), {
//                                     data: chatbotEngagementChartData,
//                                     options: getChartOptions(chartTypeMap.chatbotEngagement[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'chatbotEngagement')} filename="chatbot_engagement" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Avg Response Time</h2>
//                         <div className="h-64">
//                             {avgResponseTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.avgResponseTime[timePeriod]), {
//                                     data: avgResponseTimeChartData,
//                                     options: getChartOptions(chartTypeMap.avgResponseTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'avgResponseTime')} filename="avg_response_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Action Success Rate</h2>
//                         <div className="h-64">
//                             {actionSuccessRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.actionSuccessRate[timePeriod]), {
//                                     data: actionSuccessRateChartData,
//                                     options: getChartOptions(chartTypeMap.actionSuccessRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'actionSuccessRate')} filename="action_success_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Sales Generated</h2>
//                         <div className="h-64">
//                             {salesGeneratedChartData.datasets[0].data.some(val => val > 0) ? (
//                                 React.createElement(getChartComponent(chartTypeMap.salesGenerated[timePeriod]), {
//                                     data: salesGeneratedChartData,
//                                     options: getChartOptions(chartTypeMap.salesGenerated[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'salesGenerated')} filename="sales_generated" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Click-Through Rate</h2>
//                         <div className="h-64">
//                             {clickThroughRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.clickThroughRate[timePeriod]), {
//                                     data: clickThroughRateChartData,
//                                     options: getChartOptions(chartTypeMap.clickThroughRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'clickThroughRate')} filename="click_through_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Human Agent Queue Time</h2>
//                         <div className="h-64">
//                             {humanAgentQueueTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.humanAgentQueueTime[timePeriod]), {
//                                     data: humanAgentQueueTimeChartData,
//                                     options: getChartOptions(chartTypeMap.humanAgentQueueTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'humanAgentQueueTime')} filename="human_agent_queue_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Avg Ticket Closure Time</h2>
//                         <div className="h-64">
//                             {avgTicketClosureTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.avgTicketClosureTime[timePeriod]), {
//                                     data: avgTicketClosureTimeChartData,
//                                     options: getChartOptions(chartTypeMap.avgTicketClosureTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'avgTicketClosureTime')} filename="avg_ticket_closure_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Bounce Rate</h2>
//                         <div className="h-64">
//                             {bounceRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.bounceRate[timePeriod]), {
//                                     data: bounceRateChartData,
//                                     options: getChartOptions(chartTypeMap.bounceRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'bounceRate')} filename="bounce_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Hours Saved</h2>
//                         <div className="h-64">
//                             {hoursSavedChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.hoursSaved[timePeriod]), {
//                                     data: hoursSavedChartData,
//                                     options: getChartOptions(chartTypeMap.hoursSaved[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'hoursSaved')} filename="hours_saved" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Cost Saved</h2>
//                         <div className="h-64">
//                             {costSavedChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.costSaved[timePeriod]), {
//                                     data: costSavedChartData,
//                                     options: getChartOptions(chartTypeMap.costSaved[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'costSaved')} filename="cost_saved" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Heatmap of Day and Time</h2>
//                         <div className="h-64">
//                             <div className="grid grid-cols-9 gap-1">
//                                 <div></div>
//                                 {analyticsData[selectedApp].heatmap.hours.map((hour, hIndex) => (
//                                     <div key={hIndex} className="text-center text-xs text-primary">{hour}</div>
//                                 ))}
//                                 {analyticsData[selectedApp].heatmap.values.map((row, rIndex) => (
//                                     <React.Fragment key={rIndex}>
//                                         <div className="text-center text-xs text-primary">{analyticsData[selectedApp].heatmap.days[rIndex]}</div>
//                                         {row.map((value, cIndex) => (
//                                             <div
//                                                 key={cIndex}
//                                                 className="h-8 w-8 rounded"
//                                                 style={{ backgroundColor: `rgba(26, 82, 118, ${value / 200})` }}
//                                                 title={`${value} engagements`}
//                                             />
//                                         ))}
//                                     </React.Fragment>
//                                 ))}
//                             </div>
//                         </div>
//                         {/* <DownloadButton
//                             data={analyticsData[selectedApp].heatmap.values.flat().map((value, index) => ({
//                                 day: analyticsData[selectedApp].heatmap.days[Math.floor(index / 8)],
//                                 hour: analyticsData[selectedApp].heatmap.hours[index % 8],
//                                 value,
//                             }))}
//                             filename="heatmap"
//                         /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Flow Engagement</h2>
//                         <div className="h-64">
//                             {flowEngagementChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.flowEngagement[timePeriod]), {
//                                     data: flowEngagementChartData,
//                                     options: getChartOptions(chartTypeMap.flowEngagement[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'flowEngagement')} filename="flow_engagement" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversation Breakdown</h2>
//                         <div className="h-64">
//                             {conversationBreakdownChartData.datasets[0].data.some(val => val > 0) ? (
//                                 React.createElement(getChartComponent(chartTypeMap.conversationBreakdown[timePeriod]), {
//                                     data: conversationBreakdownChartData,
//                                     options: getChartOptions(chartTypeMap.conversationBreakdown[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton
//                             data={conversationBreakdownChartData.datasets[0].data.map((value, index) => ({
//                                 label: conversationBreakdownChartData.labels[index],
//                                 value,
//                             }))}
//                             filename="conversation_breakdown"
//                         /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Chat Volumes</h2>
//                         <div className="h-64">
//                             {chatVolumeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.chatVolumes[timePeriod]), {
//                                     data: chatVolumeChartData,
//                                     options: getChartOptions(chartTypeMap.chatVolumes[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'chatVolumes')} filename="chat_volumes" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">CSAT Score</h2>
//                         <div className="h-64">
//                             {csatScoreChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.csatScore[timePeriod]), {
//                                     data: csatScoreChartData,
//                                     options: getChartOptions(chartTypeMap.csatScore[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'csatScore')} filename="csat_score" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Feedback Fill Rate</h2>
//                         <div className="h-64">
//                             {feedbackFillRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.feedbackFillRate[timePeriod]), {
//                                     data: feedbackFillRateChartData,
//                                     options: getChartOptions(chartTypeMap.feedbackFillRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'feedbackFillRate')} filename="feedback_fill_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Escalation Rate</h2>
//                         <div className="h-64">
//                             {escalationRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.escalationRate[timePeriod]), {
//                                     data: escalationRateChartData,
//                                     options: getChartOptions(chartTypeMap.escalationRate[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'escalationRate')} filename="escalation_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Successful Closure Time</h2>
//                         <div className="h-64">
//                             {closureTimeChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.closureTime[timePeriod]), {
//                                     data: closureTimeChartData,
//                                     options: getChartOptions(chartTypeMap.closureTime[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'closureTime')} filename="closure_time" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Error Rate</h2>
//                         <div className="h-64">
//                             {errorRateChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.errors[timePeriod]), {
//                                     data: errorRateChartData,
//                                     options: getChartOptions(chartTypeMap.errors[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'errors')} filename="error_rate" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Abandoned Users</h2>
//                         <div className="h-64">
//                             {abandonedUsersChartData.labels.length > 0 ? (
//                                 React.createElement(getChartComponent(chartTypeMap.abandonedUsers[timePeriod]), {
//                                     data: abandonedUsersChartData,
//                                     options: getChartOptions(chartTypeMap.abandonedUsers[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton data={getFilteredData(analyticsData[selectedApp], 'abandonedUsers')} filename="abandoned_users" /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Agent Analytics</h2>
//                         <div className="h-64">
//                             {agentAnalyticsChartData.datasets[0].data.some(val => val > 0) ? (
//                                 React.createElement(getChartComponent(chartTypeMap.agentAnalytics[timePeriod]), {
//                                     data: agentAnalyticsChartData,
//                                     options: getChartOptions(chartTypeMap.agentAnalytics[timePeriod]),
//                                 })
//                             ) : (
//                                 <p className="text-primary text-center">No data available</p>
//                             )}
//                         </div>
//                         {/* <DownloadButton
//                             data={agentAnalyticsChartData.datasets[0].data.map((value, index) => ({
//                                 label: agentAnalyticsChartData.labels[index],
//                                 value,
//                             }))}
//                             filename="agent_analytics"
//                         /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">
//                             Acquisitions By {selectedProperty === 'all' ? 'Country' : selectedProperty.charAt(0).toUpperCase() + selectedProperty.slice(1)}
//                         </h2>
//                         <div className="overflow-x-auto">
//                             <table className="min-w-full text-left text-primary">
//                                 <thead>
//                                     <tr>
//                                         <th className="px-4 py-2">Name</th>
//                                         <th className="px-4 py-2">Chats</th>
//                                         <th className="px-4 py-2">Contacts</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {acquisitionsTableData && acquisitionsTableData.length > 0 ? (
//                                         acquisitionsTableData.map((item, index) => (
//                                             <tr key={index} className="border-t">
//                                                 <td className="px-4 py-2">{item.name}</td>
//                                                 <td className="px-4 py-2">{item.chats}</td>
//                                                 <td className="px-4 py-2">{item.contacts}</td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan={3} className="px-4 py-2 text-center">No data available</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                         {/* <DownloadButton data={acquisitionsTableData} filename={`acquisitions_by_${selectedProperty}`} /> */}
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-auto">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Top 3 Queries</h2>
//                         <ul className="list-disc pl-5 text-primary text-left">
//                             {analyticsData[selectedApp].topQueries && analyticsData[selectedApp].topQueries.length > 0 ? (
//                                 analyticsData[selectedApp].topQueries.map((query, index) => (
//                                     <li key={index} className="mb-2">{query}</li>
//                                 ))
//                             ) : (
//                                 <li className="text-primary">No queries available</li>
//                             )}
//                         </ul>
//                         {/* <DownloadButton
//                             data={analyticsData[selectedApp].topQueries.map((query, index) => ({ rank: index + 1, query }))}
//                             filename="top_queries"
//                         /> */}
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Analytics;

// import React, { useState, useEffect } from 'react';
// import { Bar, Line, Pie } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement
// } from 'chart.js';
// import axios from 'axios';
// import Layout from '../components/layout';
// import DownloadButton from '../components/downloadButton';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement);

// function Analytics() {
//     const [period, setPeriod] = useState('daily');
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [startWeek, setStartWeek] = useState('');
//     const [endWeek, setEndWeek] = useState('');
//     const [startMonth, setStartMonth] = useState('');
//     const [endMonth, setEndMonth] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [apiData, setApiData] = useState(null);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setError(null);

//         let payload;
//         if (period === 'daily') {
//             payload = { startDate, endDate };
//         } else if (period === 'weekly') {
//             payload = { startWeek, endWeek };
//         } else if (period === 'monthly') {
//             payload = { startMonth, endMonth };
//         }

//         try {
//             const response = await axios.post(
//                 'https://vibe.fixall.ai/apis/dashboardDataByRange',
//                 payload,
//                 { headers: { 'Content-Type': 'application/json' } }
//             );
//             setApiData(response.data.data);
//         } catch (err) {
//             setError('Failed to fetch data. Please try again.');
//             console.error('API Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const chartTypeMap = {
//         total_conversations: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_escalated_to_human_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_ticket_created_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_abandoned_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_thumbs_up_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_thumbs_down_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_feedback_given_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         average_closure_time_minutes: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }
//     };

//     const getChartComponent = (chartType) => {
//         switch (chartType) {
//             case 'Line': return Line;
//             case 'Bar': return Bar;
//             case 'Pie': return Pie;
//             default: return Bar;
//         }
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: (context) => `${context.dataset.label}: ${context.parsed.y || context.parsed}`
//                 }
//             }
//         },
//         scales: {
//             y: { beginAtZero: true, title: { display: true, text: 'Value' } },
//             x: { title: { display: true, text: period.charAt(0).toUpperCase() + period.slice(1) } }
//         }
//     };

//     const pieChartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: (context) => `${context.label}: ${context.parsed}`
//                 }
//             }
//         }
//     };

//     const getChartOptions = (chartType) => chartType === 'Pie' ? pieChartOptions : chartOptions;

//     const createChartData = (key, label) => ({
//         labels: apiData?.[key]?.map(item => item.date || item.week || item.month) || [],
//         datasets: [{
//             label,
//             data: apiData?.[key]?.map(item => item.value) || [],
//             borderColor: '#1A5276',
//             backgroundColor: period === 'monthly' ? ['#1A5276', '#F87171', '#34D399'] : '#1A5276',
//             fill: chartTypeMap[key][period] === 'Line'
//         }]
//     });

//     const charts = [
//         { key: 'total_conversations', label: 'Total Conversations' },
//         { key: 'total_escalated_to_human_true', label: 'Escalated to Human' },
//         { key: 'total_ticket_created_true', label: 'Tickets Created' },
//         { key: 'total_abandoned_true', label: 'Abandoned Conversations' },
//         { key: 'total_thumbs_up_true', label: 'Thumbs Up' },
//         { key: 'total_thumbs_down_true', label: 'Thumbs Down' },
//         { key: 'total_feedback_given_true', label: 'Feedback Given' },
//         { key: 'average_closure_time_minutes', label: 'Average Closure Time (min)' }
//     ];

//     const allAnalyticsData = charts.flatMap(({ key, label }) =>
//         apiData?.[key]?.map(item => ({
//             Metric: label,
//             TimePeriod: period,
//             Date: item.date || item.week || item.month || '',
//             Value: item.value
//         })) || []
//     );

//     return (
//         <Layout>
//             <div className="p-6 bg-gray-100 min-h-screen">
//                 {/* <div className="mb-6 p-6 bg-white rounded-lg shadow-md">
//                     <form onSubmit={handleSubmit} className="space-y-4 flex">
//                         <div>
//                             <label htmlFor="period" className="block text-sm font-medium text-gray-700">Time Period</label>
//                             <select
//                                 id="period"
//                                 value={period}
//                                 onChange={(e) => setPeriod(e.target.value)}
//                                 className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                             >
//                                 <option value="daily">Daily</option>
//                                 <option value="weekly">Weekly</option>
//                                 <option value="monthly">Monthly</option>
//                             </select>
//                         </div>
//                         {period === 'daily' && (
//                             <>
//                                 <div>
//                                     <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">Start Date</label>
//                                     <input
//                                         type="date"
//                                         id="startDate"
//                                         value={startDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                                     />
//                                 </div>
//                                 <div>
//                                     <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">End Date</label>
//                                     <input
//                                         type="date"
//                                         id="endDate"
//                                         value={endDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}
//                         {period === 'weekly' && (
//                             <>
//                                 <div>
//                                     <label htmlFor="startWeek" className="block text-sm font-medium text-gray-700">Start Week</label>
//                                     <input
//                                         type="week"
//                                         id="startWeek"
//                                         value={startWeek}
//                                         onChange={(e) => setStartWeek(e.target.value)}
//                                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                                     />
//                                 </div>
//                                 <div>
//                                     <label htmlFor="endWeek" className="block text-sm font-medium text-gray-700">End Week</label>
//                                     flickering issue with charts, fix it
//                                     <input
//                                         type="week"
//                                         id="endWeek"
//                                         value={endWeek}
//                                         onChange={(e) => setEndWeek(e.target.value)}
//                                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}
//                         {period === 'monthly' && (
//                             <>
//                                 <div>
//                                     <label htmlFor="startMonth" className="block text-sm font-medium text-gray-700">Start Month</label>
//                                     <input
//                                         type="month"
//                                         id="startMonth"
//                                         value={startMonth}
//                                         onChange={(e) => setStartMonth(e.target.value)}
//                                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                                     />
//                                 </div>
//                                 <div>
//                                     <label htmlFor="endMonth" className="block text-sm font-medium text-gray-700">End Month</label>
//                                     <input
//                                         type="month"
//                                         id="endMonth"
//                                         value={endMonth}
//                                         onChange={(e) => setEndMonth(e.target.value)}
//                                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}
//                     </form>
//                         <button
//                             type="submit"
//                             disabled={loading}
//                             className={`w-full py-2 px-4 rounded-md text-white ${loading ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500'} focus:outline-none`}
//                         >
//                             {loading ? 'Loading...' : 'Apply Filter'}
//                         </button>
//                 </div> */}

//                 <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
//                     <h2 className="text-xl font-semibold text-primary">Download Analytics Data</h2>
//                     <DownloadButton data={allAnalyticsData} filename={`analytics_${period}`} />
//                 </div>
//                 <div className="mb-6 p-6 bg-white rounded-xl shadow-lg border border-gray-200">
//                     <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
//                         {/* Time Period */}
//                         <div className="w-full md:w-1/5">
//                             <label htmlFor="period" className="text-sm font-medium text-gray-600 mb-1 block">Time Period</label>
//                             <select
//                                 id="period"
//                                 value={period}
//                                 onChange={(e) => setPeriod(e.target.value)}
//                                 className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                             >
//                                 <option value="">Select</option>
//                                 <option value="daily">Daily</option>
//                                 <option value="weekly">Weekly</option>
//                                 <option value="monthly">Monthly</option>
//                             </select>
//                         </div>

//                         {/* Conditional Inputs */}
//                         {period === 'daily' && (
//                             <>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="startDate" className="text-sm font-medium text-gray-600 mb-1 block">Start Date</label>
//                                     <input
//                                         type="date"
//                                         id="startDate"
//                                         value={startDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="endDate" className="text-sm font-medium text-gray-600 mb-1 block">End Date</label>
//                                     <input
//                                         type="date"
//                                         id="endDate"
//                                         value={endDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}

//                         {period === 'weekly' && (
//                             <>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="startWeek" className="text-sm font-medium text-gray-600 mb-1 block">Start Week</label>
//                                     <input
//                                         type="week"
//                                         id="startWeek"
//                                         value={startWeek}
//                                         onChange={(e) => setStartWeek(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="endWeek" className="text-sm font-medium text-gray-600 mb-1 block">End Week</label>
//                                     <input
//                                         type="week"
//                                         id="endWeek"
//                                         value={endWeek}
//                                         onChange={(e) => setEndWeek(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}

//                         {period === 'monthly' && (
//                             <>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="startMonth" className="text-sm font-medium text-gray-600 mb-1 block">Start Month</label>
//                                     <input
//                                         type="month"
//                                         id="startMonth"
//                                         value={startMonth}
//                                         onChange={(e) => setStartMonth(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="endMonth" className="text-sm font-medium text-gray-600 mb-1 block">End Month</label>
//                                     <input
//                                         type="month"
//                                         id="endMonth"
//                                         value={endMonth}
//                                         onChange={(e) => setEndMonth(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}

//                         {/* Submit Button aligned right */}
//                         <div className="w-full md:ml-auto md:w-1/5">
//                             <button
//                                 type="submit"
//                                 disabled={loading}
//                                 className={`w-full mt-4 py-2 px-4 rounded-md text-white font-medium ${loading
//                                     ? 'bg-indigo-300 cursor-not-allowed'
//                                     : 'bg-primary hover:bg-secondary text-secondary hover:text-primary border hover:border-primary focus:ring-2 focus:ring-indigo-500'
//                                     }`}
//                             >
//                                 {loading ? 'Loading...' : 'Apply Filter'}
//                             </button>
//                         </div>
//                     </form>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {charts.map(({ key, label }) => (
//                         <div key={key} className="bg-white p-4 rounded-lg shadow-md h-auto">
//                             <h2 className="text-xl font-semibold text-primary mb-4">{label}</h2>
//                             <div className="h-64">
//                                 {apiData?.[key]?.length > 0 ? (
//                                     React.createElement(getChartComponent(chartTypeMap[key][period]), {
//                                         data: createChartData(key, label),
//                                         options: getChartOptions(chartTypeMap[key][period])
//                                     })
//                                 ) : (
//                                     <p className="text-primary text-center">No data available</p>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Analytics;

// import React, { useState, useEffect } from 'react';
// import { Bar, Line, Pie } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement
// } from 'chart.js';
// import axios from 'axios';
// import Layout from '../components/layout';
// import DownloadButton from '../components/downloadButton';
// import { apiurl } from '../config/config';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement);

// function Analytics() {
//     const [period, setPeriod] = useState('daily');
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [startWeek, setStartWeek] = useState('');
//     const [endWeek, setEndWeek] = useState('');
//     const [startMonth, setStartMonth] = useState('');
//     const [endMonth, setEndMonth] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [apiData, setApiData] = useState(null);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setError(null);

//         let payload;
//         if (period === 'daily') {
//             payload = { startDate, endDate };
//         } else if (period === 'weekly') {
//             payload = { startWeek, endWeek };
//         } else if (period === 'monthly') {
//             payload = { startMonth, endMonth };
//         }

//         try {
//             const response = await axios.post(
//                 `${apiurl}/apis/dashboardDataByRange`,
//                 payload,
//                 { headers: { 'Content-Type': 'application/json' } }
//             );
//             setApiData(response.data.data);
//         } catch (err) {
//             setError('Failed to fetch data. Please try again.');
//             console.error('API Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const chartTypeMap = {
//         total_conversations: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_escalated_to_human_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_ticket_created_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_abandoned_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_thumbs_up_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_thumbs_down_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         total_feedback_given_true: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' },
//         average_closure_time_minutes: { daily: 'Line', weekly: 'Bar', monthly: 'Pie' }
//     };

//     const getChartComponent = (chartType) => {
//         switch (chartType) {
//             case 'Line': return Line;
//             case 'Bar': return Bar;
//             case 'Pie': return Pie;
//             default: return Bar;
//         }
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: (context) => `${context.dataset.label}: ${context.parsed.y || context.parsed}`
//                 }
//             }
//         },
//         scales: {
//             y: { beginAtZero: true, title: { display: true, text: 'Value' } },
//             x: { title: { display: true, text: period.charAt(0).toUpperCase() + period.slice(1) } }
//         }
//     };

//     const pieChartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { position: 'top' },
//             tooltip: {
//                 callbacks: {
//                     label: (context) => `${context.label}: ${context.parsed}`
//                 }
//             }
//         }
//     };

//     const getChartOptions = (chartType) => chartType === 'Pie' ? pieChartOptions : chartOptions;

//     // Expanded color palette for multiple datasets or data points
//     const colorPalette = [
//         '#FF6B6B', // Red
//         '#4ECDC4', // Teal
//         '#45B7D1', // Blue
//         '#96CEB4', // Green
//         '#FFEEAD', // Yellow
//         '#D4A5A5', // Pink
//         '#9B59B6', // Purple
//         '#3498DB', // Bright Blue
//         '#E74C3C', // Coral
//         '#2ECC71', // Emerald
//         '#F1C40F', // Gold
//         '#34495E'  // Dark Blue
//     ];

//     const createChartData = (key, label) => {
//         const chartType = chartTypeMap[key][period];
//         const labels = apiData?.[key]?.map(item => item.date || item.week || item.month) || [];
//         const values = apiData?.[key]?.map(item => item.value) || [];

//         let datasets = [];

//         if (chartType === 'Pie') {
//             datasets = [{
//                 label,
//                 data: values,
//                 backgroundColor: labels.map((_, index) => colorPalette[index % colorPalette.length]),
//                 borderColor: '#FFFFFF',
//                 borderWidth: 2
//             }];
//         } else if (chartType === 'Bar') {
//             datasets = [{
//                 label,
//                 data: values,
//                 backgroundColor: labels.map((_, index) => colorPalette[index % colorPalette.length]),
//                 borderColor: labels.map((_, index) => colorPalette[index % colorPalette.length]),
//                 borderWidth: 1
//             }];
//         } else if (chartType === 'Line') {
//             // For Line charts, we'll assume a single dataset for simplicity, but use a unique color
//             datasets = [{
//                 label,
//                 data: values,
//                 borderColor: colorPalette[charts.findIndex(c => c.key === key) % colorPalette.length],
//                 backgroundColor: colorPalette[charts.findIndex(c => c.key === key) % colorPalette.length] + '33', // Add transparency
//                 fill: true,
//                 tension: 0.4
//             }];
//         }

//         return {
//             labels,
//             datasets
//         };
//     };

//     const charts = [
//         { key: 'total_conversations', label: 'Total Conversations' },
//         { key: 'total_escalated_to_human_true', label: 'Escalated to Human' },
//         { key: 'total_ticket_created_true', label: 'Tickets Created' },
//         { key: 'total_abandoned_true', label: 'Abandoned Conversations' },
//         { key: 'total_thumbs_up_true', label: 'Thumbs Up' },
//         { key: 'total_thumbs_down_true', label: 'Thumbs Down' },
//         { key: 'total_feedback_given_true', label: 'Feedback Given' },
//         { key: 'average_closure_time_minutes', label: 'Average Closure Time (min)' }
//     ];

//     const allAnalyticsData = charts.flatMap(({ key, label }) =>
//         apiData?.[key]?.map(item => ({
//             Metric: label,
//             TimePeriod: period,
//             Date: item.date || item.week || item.month || '',
//             Value: item.value
//         })) || []
//     );

//     return (
//         <Layout>
//             <div className="p-6 bg-gray-100 min-h-screen">
//                 <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
//                     <h2 className="text-xl font-semibold text-primary">Download Analytics Data</h2>
//                     <DownloadButton data={allAnalyticsData} filename={`analytics_${period}`} />
//                 </div>
//                 <div className="mb-6 p-6 bg-white rounded-xl shadow-lg border border-gray-200">
//                     <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
//                         <div className="w-full md:w-1/5">
//                             <label htmlFor="period" className="text-sm font-medium text-gray-600 mb-1 block">Time Period</label>
//                             <select
//                                 id="period"
//                                 value={period}
//                                 onChange={(e) => setPeriod(e.target.value)}
//                                 className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                             >
//                                 <option value="">Select</option>
//                                 <option value="daily">Daily</option>
//                                 <option value="weekly">Weekly</option>
//                                 <option value="monthly">Monthly</option>
//                             </select>
//                         </div>
//                         {period === 'daily' && (
//                             <>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="startDate" className="text-sm font-medium text-gray-600 mb-1 block">Start Date</label>
//                                     <input
//                                         type="date"
//                                         id="startDate"
//                                         value={startDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="endDate" className="text-sm font-medium text-gray-600 mb-1 block">End Date</label>
//                                     <input
//                                         type="date"
//                                         id="endDate"
//                                         value={endDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}
//                         {period === 'weekly' && (
//                             <>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="startWeek" className="text-sm font-medium text-gray-600 mb-1 block">Start Week</label>
//                                     <input
//                                         type="week"
//                                         id="startWeek"
//                                         value={startWeek}
//                                         onChange={(e) => setStartWeek(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="endWeek" className="text-sm font-medium text-gray-600 mb-1 block">End Week</label>
//                                     <input
//                                         type="week"
//                                         id="endWeek"
//                                         value={endWeek}
//                                         onChange={(e) => setEndWeek(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}
//                         {period === 'monthly' && (
//                             <>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="startMonth" className="text-sm font-medium text-gray-600 mb-1 block">Start Month</label>
//                                     <input
//                                         type="month"
//                                         id="startMonth"
//                                         value={startMonth}
//                                         onChange={(e) => setStartMonth(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                                 <div className="w-full md:w-1/5">
//                                     <label htmlFor="endMonth" className="text-sm font-medium text-gray-600 mb-1 block">End Month</label>
//                                     <input
//                                         type="month"
//                                         id="endMonth"
//                                         value={endMonth}
//                                         onChange={(e) => setEndMonth(e.target.value)}
//                                         className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                                     />
//                                 </div>
//                             </>
//                         )}
//                         <div className="w-full md:ml-auto md:w-1/5">
//                             <button
//                                 type="submit"
//                                 disabled={loading}
//                                 className={`w-full mt-4 py-2 px-4 rounded-md text-white font-medium ${loading
//                                     ? 'bg-indigo-300 cursor-not-allowed'
//                                     : 'bg-primary hover:bg-secondary text-secondary hover:text-primary border hover:border-primary focus:ring-2 focus:ring-indigo-500'
//                                     }`}
//                             >
//                                 {loading ? 'Loading...' : 'Apply Filter'}
//                             </button>
//                         </div>
//                     </form>
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {charts.map(({ key, label }) => (
//                         <div key={key} className="bg-white p-4 rounded-lg shadow-md h-auto">
//                             <h2 className="text-xl font-semibold text-primary mb-4">{label}</h2>
//                             <div className="h-64">
//                                 {apiData?.[key]?.length > 0 ? (
//                                     React.createElement(getChartComponent(chartTypeMap[key][period]), {
//                                         data: createChartData(key, label),
//                                         options: getChartOptions(chartTypeMap[key][period])
//                                     })
//                                 ) : (
//                                     <p className="text-primary text-center">No data available</p>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Analytics;







// import React, { useState, useEffect } from "react";
// import { Bar, Line, Pie } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
// } from "chart.js";
// import axios from "axios";
// import Layout from "../components/layout";
// import DownloadButton from "../components/downloadButton";
// import { apiurl } from "../config/config";

// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement
// );

// function Analytics() {
//   const [period, setPeriod] = useState("daily");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [startWeek, setStartWeek] = useState("");
//   const [endWeek, setEndWeek] = useState("");
//   const [startMonth, setStartMonth] = useState("");
//   const [endMonth, setEndMonth] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [apiData, setApiData] = useState(null);

//   console.log("apiDataTotal", apiData?.totals);

//   const fetchApiData = async () => {
//     setLoading(true);
//     setError(null);

//     let payload;
//     if (period === "daily") {
//       payload = { startDate, endDate };
//     } else if (period === "weekly") {
//       payload = { startWeek, endWeek };
//     } else if (period === "monthly") {
//       payload = { startMonth, endMonth };
//     }

//     try {
//       const response = await axios.post(
//         `${apiurl}/apis/dashboardDataByRange`,
//         payload,
//         { headers: { "Content-Type": "application/json" } }
//       );
//       setApiData(response.data);
//     } catch (err) {
//       setError("Failed to fetch data. Please try again.");
//       console.error("API Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // Set default values for daily period and date range
//     const today = new Date();
//     // Explicitly set first day of current month
//     const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

//     // Format dates as YYYY-MM-DD
//     const formatDate = (date) => {
//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//       const day = String(date.getDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     };

//     const defaultStartDate = formatDate(firstDayOfMonth);
//     const defaultEndDate = formatDate(today);

//     // Update state
//     setPeriod("daily");
//     setStartDate(defaultStartDate);
//     setEndDate(defaultEndDate);

//     // Call API with default values
//     const payload = { startDate: defaultStartDate, endDate: defaultEndDate };
//     setLoading(true);
//     setError(null);

//     axios
//       .post(`${apiurl}/apis/dashboardDataByRange`, payload, {
//         headers: { "Content-Type": "application/json" },
//       })
//       .then((response) => {
//         setApiData(response.data);
//       })
//       .catch((err) => {
//         setError("Failed to fetch data. Please try again.");
//         console.error("API Error:", err);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []); // Empty dependency array to run only on mount

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     await fetchApiData();
//   };

//   const chartTypeMap = {
//     total_conversations: { daily: "Line", weekly: "Bar", monthly: "Pie" },
//     total_escalated_to_human_true: {
//       daily: "Line",
//       weekly: "Bar",
//       monthly: "Pie",
//     },
//     total_ticket_created_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
//     total_abandoned_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
//     total_thumbs_up_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
//     total_thumbs_down_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
//     total_feedback_given_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
//     average_closure_time_minutes: {
//       daily: "Line",
//       weekly: "Bar",
//       monthly: "Pie",
//     },
//   };

//   const getChartComponent = (chartType) => {
//     switch (chartType) {
//       case "Line":
//         return Line;
//       case "Bar":
//         return Bar;
//       case "Pie":
//         return Pie;
//       default:
//         return Bar;
//     }
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { position: "top" },
//       tooltip: {
//         callbacks: {
//           label: (context) =>
//             `${context.dataset.label}: ${context.parsed.y || context.parsed}`,
//         },
//       },
//     },
//     scales: {
//       y: { beginAtZero: true, title: { display: true, text: "Value" } },
//       x: {
//         title: {
//           display: true,
//           text: period.charAt(0).toUpperCase() + period.slice(1),
//         },
//       },
//     },
//   };

//   const pieChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { position: "top" },
//       tooltip: {
//         callbacks: {
//           label: (context) => `${context.label}: ${context.parsed}`,
//         },
//       },
//     },
//   };

//   const getChartOptions = (chartType) =>
//     chartType === "Pie" ? pieChartOptions : chartOptions;

//   // Expanded color palette for multiple datasets or data points
//   const colorPalette = [
//     "#FF6B6B", // Red
//     "#4ECDC4", // Teal
//     "#45B7D1", // Blue
//     "#96CEB4", // Green
//     "#FFEEAD", // Yellow
//     "#D4A5A5", // Pink
//     "#9B59B6", // Purple
//     "#3498DB", // Bright Blue
//     "#E74C3C", // Coral
//     "#2ECC71", // Emerald
//     "#F1C40F", // Gold
//     "#34495E", // Dark Blue
//   ];

//   const createChartData = (key, label) => {
//     const chartType = chartTypeMap[key][period];
//     const labels =
//       apiData?.data?.[key]?.map(
//         (item) => item.date || item.week || item.month
//       ) || [];
//     const values = apiData?.data?.[key]?.map((item) => item.value) || [];

//     let datasets = [];

//     if (chartType === "Pie") {
//       datasets = [
//         {
//           label,
//           data: values,
//           backgroundColor: labels.map(
//             (_, index) => colorPalette[index % colorPalette.length]
//           ),
//           borderColor: "#FFFFFF",
//           borderWidth: 2,
//         },
//       ];
//     } else if (chartType === "Bar") {
//       datasets = [
//         {
//           label,
//           data: values,
//           backgroundColor: labels.map(
//             (_, index) => colorPalette[index % colorPalette.length]
//           ),
//           borderColor: labels.map(
//             (_, index) => colorPalette[index % colorPalette.length]
//           ),
//           borderWidth: 1,
//         },
//       ];
//     } else if (chartType === "Line") {
//       datasets = [
//         {
//           label,
//           data: values,
//           borderColor:
//             colorPalette[
//               charts.findIndex((c) => c.key === key) % colorPalette.length
//             ],
//           backgroundColor:
//             colorPalette[
//               charts.findIndex((c) => c.key === key) % colorPalette.length
//             ] + "33", // Add transparency
//           fill: true,
//           tension: 0.4,
//         },
//       ];
//     }

//     return {
//       labels,
//       datasets,
//     };
//   };

//   const charts = [
//     { key: "total_conversations", label: "Total Conversations" },
//     { key: "total_escalated_to_human_true", label: "Escalated to Human" },
//     { key: "total_ticket_created_true", label: "Tickets Created" },
//     { key: "total_abandoned_true", label: "Abandoned Conversations" },
//     { key: "total_thumbs_up_true", label: "Thumbs Up" },
//     { key: "total_thumbs_down_true", label: "Thumbs Down" },
//     { key: "total_feedback_given_true", label: "Feedback Given" },
//     {
//       key: "average_closure_time_minutes",
//       label: "Average Closure Time (min)",
//     },
//   ];

//   const allAnalyticsData = charts.flatMap(
//     ({ key, label }) =>
//       apiData?.data?.[key]?.map((item) => ({
//         Metric: label,
//         TimePeriod: period,
//         Date: item.date || item.week || item.month || "",
//         Value: item.value,
//       })) || []
//   );

//   return (
//     <Layout>
//       <div className="p-6 bg-gray-100 min-h-screen">
//         <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
//           <h2 className="text-xl font-semibold text-primary">
//             Download Analytics Data
//           </h2>
//           <DownloadButton
//             data={allAnalyticsData}
//             filename={`analytics_${period}`}
//           />
//         </div>
//         <div className="mb-6 p-6 bg-white rounded-xl shadow-lg border border-gray-200">
//           <form
//             onSubmit={handleSubmit}
//             className="flex flex-wrap items-end gap-4"
//           >
//             <div className="w-full md:w-1/5">
//               <label
//                 htmlFor="period"
//                 className="text-sm font-medium text-gray-600 mb-1 block"
//               >
//                 Time Period
//               </label>
//               <select
//                 id="period"
//                 value={period}
//                 onChange={(e) => setPeriod(e.target.value)}
//                 className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//               >
//                 <option value="daily">Daily</option>
//                 <option value="weekly">Weekly</option>
//                 <option value="monthly">Monthly</option>
//               </select>
//             </div>
//             {period === "daily" && (
//               <>
//                 <div className="w-full md:w-1/5">
//                   <label
//                     htmlFor="startDate"
//                     className="text-sm font-medium text-gray-600 mb-1 block"
//                   >
//                     Start Date
//                   </label>
//                   <input
//                     type="date"
//                     id="startDate"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                   />
//                 </div>
//                 <div className="w-full md:w-1/5">
//                   <label
//                     htmlFor="endDate"
//                     className="text-sm font-medium text-gray-600 mb-1 block"
//                   >
//                     End Date
//                   </label>
//                   <input
//                     type="date"
//                     id="endDate"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                   />
//                 </div>
//               </>
//             )}
//             {period === "weekly" && (
//               <>
//                 <div className="w-full md:w-1/5">
//                   <label
//                     htmlFor="startWeek"
//                     className="text-sm font-medium text-gray-600 mb-1 block"
//                   >
//                     Start Week
//                   </label>
//                   <input
//                     type="week"
//                     id="startWeek"
//                     value={startWeek}
//                     onChange={(e) => setStartWeek(e.target.value)}
//                     className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                   />
//                 </div>
//                 <div className="w-full md:w-1/5">
//                   <label
//                     htmlFor="endWeek"
//                     className="text-sm font-medium text-gray-600 mb-1 block"
//                   >
//                     End Week
//                   </label>
//                   <input
//                     type="week"
//                     id="endWeek"
//                     value={endWeek}
//                     onChange={(e) => setEndWeek(e.target.value)}
//                     className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                   />
//                 </div>
//               </>
//             )}
//             {period === "monthly" && (
//               <>
//                 <div className="w-full md:w-1/5">
//                   <label
//                     htmlFor="startMonth"
//                     className="text-sm font-medium text-gray-600 mb-1 block"
//                   >
//                     Start Month
//                   </label>
//                   <input
//                     type="month"
//                     id="startMonth"
//                     value={startMonth}
//                     onChange={(e) => setStartMonth(e.target.value)}
//                     className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                   />
//                 </div>
//                 <div className="w-full md:w-1/5">
//                   <label
//                     htmlFor="endMonth"
//                     className="text-sm font-medium text-gray-600 mb-1 block"
//                   >
//                     End Month
//                   </label>
//                   <input
//                     type="month"
//                     id="endMonth"
//                     value={endMonth}
//                     onChange={(e) => setEndMonth(e.target.value)}
//                     className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
//                   />
//                 </div>
//               </>
//             )}
//             <div className="w-full md:ml-auto md:w-1/5">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className={`w-full mt-4 py-2 px-4 rounded-md text-white font-medium ${
//                   loading
//                     ? "bg-indigo-300 cursor-not-allowed"
//                     : "bg-primary hover:bg-secondary text-secondary hover:text-primary border hover:border-primary focus:ring-2 focus:ring-indigo-500"
//                 }`}
//               >
//                 {loading ? "Loading..." : "Apply Filter"}
//               </button>
//             </div>
//           </form>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {/* {charts.map(({ key, label }) => (
//                         <div key={key} className="bg-white p-4 rounded-lg shadow-md h-auto">
//                             <h2 className="text-xl font-semibold text-primary mb-4">{label}</h2>
//                             <div className="h-64">
//                                 {apiData?.data?.[key]?.length > 0 ? (
//                                     React.createElement(getChartComponent(chartTypeMap[key][period]), {
//                                         data: createChartData(key, label),
//                                         options: getChartOptions(chartTypeMap[key][period])
//                                     })
//                                 ) : (
//                                     <p className="text-primary text-center">No data available</p>
//                                 )}
//                             </div>
//                         </div>
//                     ))} */}

//           {charts.map(({ key, label }) => (

//             <div key={key} className="bg-white p-4 rounded-lg shadow-md h-auto">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-lg font-semibold text-primary">{label}</h2>
//                 <div className="bg-blue-100 px-4 py-2 rounded-3xl flex flex-shrink-0 text-sm">
//                   {apiData?.totals && (
//                     <p className="font-semibold text-primary">
//                       {/* Total:{" "} */}
//                       {key === "average_closure_time_minutes"
//                         ? apiData.totals[key]?.toFixed(2) || "N/A"
//                         : apiData.totals[key] || "N/A"}
//                       {key === "average_closure_time_minutes" && " min"}
//                     </p>
//                   )}
//                 </div>
//               </div>
//               <div className="h-64">
//                 {apiData?.data?.[key]?.length > 0 ? (
//                   React.createElement(
//                     getChartComponent(chartTypeMap[key][period]),
//                     {
//                       data: createChartData(key, label),
//                       options: getChartOptions(chartTypeMap[key][period]),
//                     }
//                   )
//                 ) : (
//                   <p className="text-primary text-center">No data available</p>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </Layout>
//   );
// }

// export default Analytics;







import React, { useState, useEffect } from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
} from "chart.js";
import axios from "axios";
import Layout from "../components/layout";
import DownloadButton from "../components/downloadButton";
import { apiurl } from "../config/config";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
);

function Analytics() {
  const [period, setPeriod] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startWeek, setStartWeek] = useState("");
  const [endWeek, setEndWeek] = useState("");
  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);
  const [apiData, setApiData] = useState(null);

  const fetchApiData = async () => {
    setLoading(true);
    // setError(null);

    let payload;
    if (period === "daily") {
      payload = { startDate, endDate };
    } else if (period === "weekly") {
      payload = { startWeek, endWeek };
    } else if (period === "monthly") {
      payload = { startMonth, endMonth };
    }

    try {
      const response = await axios.post(
        `${apiurl}/apis/dashboardDataByRange`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      setApiData(response.data);
    } catch (err) {
      // setError("Failed to fetch data. Please try again.");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Set default values for daily period and date range
    const today = new Date();
    // Explicitly set first day of current month
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    // Format dates as YYYY-MM-DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const defaultStartDate = formatDate(firstDayOfMonth);
    const defaultEndDate = formatDate(today);

    // Update state
    setPeriod("daily");
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);

    // Call API with default values
    const payload = { startDate: defaultStartDate, endDate: defaultEndDate };
    setLoading(true);
    // setError(null);

    axios
      .post(`${apiurl}/apis/dashboardDataByRange`, payload, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        setApiData(response.data);
      })
      .catch((err) => {
        // setError("Failed to fetch data. Please try again.");
        console.error("API Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); // Empty dependency array to run only on mount

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetchApiData();
  };

  const chartTypeMap = {
    total_conversations: { daily: "Line", weekly: "Bar", monthly: "Pie" },
    total_escalated_to_human_true: {
      daily: "Line",
      weekly: "Bar",
      monthly: "Pie",
    },
    total_ticket_created_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
    total_abandoned_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
    total_thumbs_up_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
    total_thumbs_down_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
    total_feedback_given_true: { daily: "Line", weekly: "Bar", monthly: "Pie" },
    average_closure_time_minutes: {
      daily: "Line",
      weekly: "Bar",
      monthly: "Pie",
    },
  };

  const getChartComponent = (chartType) => {
    switch (chartType) {
      case "Line":
        return Line;
      case "Bar":
        return Bar;
      case "Pie":
        return Pie;
      default:
        return Bar;
    }
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: (context) =>
            `${context.dataset.label}: ${context.parsed.y || context.parsed}`,
        },
      },
    },
    scales: {
      y: { beginAtZero: true, title: { display: true, text: "Value" } },
      x: {
        title: {
          display: true,
          text: period.charAt(0).toUpperCase() + period.slice(1),
        },
      },
    },
  };

  const pieChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.parsed}`,
        },
      },
    },
  };

  const getChartOptions = (chartType) =>
    chartType === "Pie" ? pieChartOptions : chartOptions;

  // Expanded color palette for multiple datasets or data points
  const colorPalette = [
    "#FF6B6B", // Red
    "#4ECDC4", // Teal
    "#45B7D1", // Blue
    "#96CEB4", // Green
    "#FFEEAD", // Yellow
    "#D4A5A5", // Pink
    "#9B59B6", // Purple
    "#3498DB", // Bright Blue
    "#E74C3C", // Coral
    "#2ECC71", // Emerald
    "#F1C40F", // Gold
    "#34495E", // Dark Blue
  ];

  const createChartData = (key, label) => {
    const chartType = chartTypeMap[key][period];
    const labels =
      apiData?.data?.[key]?.map(
        (item) => item.date || item.week || item.month
      ) || [];
    const values = apiData?.data?.[key]?.map((item) => item.value) || [];

    let datasets = [];

    if (chartType === "Pie") {
      datasets = [
        {
          label,
          data: values,
          backgroundColor: labels.map(
            (_, index) => colorPalette[index % colorPalette.length]
          ),
          borderColor: "#FFFFFF",
          borderWidth: 2,
        },
      ];
    } else if (chartType === "Bar") {
      datasets = [
        {
          label,
          data: values,
          backgroundColor: labels.map(
            (_, index) => colorPalette[index % colorPalette.length]
          ),
          borderColor: labels.map(
            (_, index) => colorPalette[index % colorPalette.length]
          ),
          borderWidth: 1,
        },
      ];
    } else if (chartType === "Line") {
      datasets = [
        {
          label,
          data: values,
          borderColor:
            colorPalette[
              charts.findIndex((c) => c.key === key) % colorPalette.length
            ],
          backgroundColor:
            colorPalette[
              charts.findIndex((c) => c.key === key) % colorPalette.length
            ] + "33", // Add transparency
          fill: true,
          tension: 0.4,
        },
      ];
    }

    return {
      labels,
      datasets,
    };
  };

  const charts = [
    { key: "total_conversations", label: "Total Conversations" },
    { key: "total_escalated_to_human_true", label: "Escalated to Human" },
    { key: "total_ticket_created_true", label: "Tickets Created" },
    { key: "total_abandoned_true", label: "Abandoned Conversations" },
    { key: "total_thumbs_up_true", label: "Thumbs Up" },
    { key: "total_thumbs_down_true", label: "Thumbs Down" },
    { key: "total_feedback_given_true", label: "Feedback Given" },
    {
      key: "average_closure_time_minutes",
      label: "Average Closure Time (min)",
    },
  ];

  const allAnalyticsData = charts.flatMap(
    ({ key, label }) =>
      apiData?.data?.[key]?.map((item) => ({
        Metric: label,
        TimePeriod: period,
        Date: item.date || item.week || item.month || "",
        Value: item.value,
      })) || []
  );

  return (
    <Layout>
      <div className="p-6 bg-gray-100 min-h-screen">
        <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
          <h2 className="text-xl font-semibold text-primary">
            Download Analytics Data
          </h2>
          <DownloadButton
            data={allAnalyticsData}
            filename={`analytics_${period}`}
          />
        </div>
        <div className="mb-6 p-6 bg-white rounded-xl shadow-lg border border-gray-200">
          <form
            onSubmit={handleSubmit}
            className="flex flex-wrap items-end gap-4"
          >
            <div className="w-full md:w-1/5">
              <label
                htmlFor="period"
                className="text-sm font-medium text-gray-600 mb-1 block"
              >
                Time Period
              </label>
              <select
                id="period"
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
            {period === "daily" && (
              <>
                <div className="w-full md:w-1/5">
                  <label
                    htmlFor="startDate"
                    className="text-sm font-medium text-gray-600 mb-1 block"
                  >
                    Start Date
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                </div>
                <div className="w-full md:w-1/5">
                  <label
                    htmlFor="endDate"
                    className="text-sm font-medium text-gray-600 mb-1 block"
                  >
                    End Date
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                </div>
              </>
            )}
            {period === "weekly" && (
              <>
                <div className="w-full md:w-1/5">
                  <label
                    htmlFor="startWeek"
                    className="text-sm font-medium text-gray-600 mb-1 block"
                  >
                    Start Week
                  </label>
                  <input
                    type="week"
                    id="startWeek"
                    value={startWeek}
                    onChange={(e) => setStartWeek(e.target.value)}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                </div>
                <div className="w-full md:w-1/5">
                  <label
                    htmlFor="endWeek"
                    className="text-sm font-medium text-gray-600 mb-1 block"
                  >
                    End Week
                  </label>
                  <input
                    type="week"
                    id="endWeek"
                    value={endWeek}
                    onChange={(e) => setEndWeek(e.target.value)}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                </div>
              </>
            )}
            {period === "monthly" && (
              <>
                <div className="w-full md:w-1/5">
                  <label
                    htmlFor="startMonth"
                    className="text-sm font-medium text-gray-600 mb-1 block"
                  >
                    Start Month
                  </label>
                  <input
                    type="month"
                    id="startMonth"
                    value={startMonth}
                    onChange={(e) => setStartMonth(e.target.value)}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                </div>
                <div className="w-full md:w-1/5">
                  <label
                    htmlFor="endMonth"
                    className="text-sm font-medium text-gray-600 mb-1 block"
                  >
                    End Month
                  </label>
                  <input
                    type="month"
                    id="endMonth"
                    value={endMonth}
                    onChange={(e) => setEndMonth(e.target.value)}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                </div>
              </>
            )}
            <div className="w-full md:ml-auto md:w-1/5">
              <button
                type="submit"
                disabled={loading}
                className={`w-full mt-4 py-2 px-4 rounded-md text-white font-medium ${
                  loading
                    ? "bg-indigo-300 cursor-not-allowed"
                    : "bg-primary hover:bg-secondary text-secondary hover:text-primary border hover:border-primary focus:ring-2 focus:ring-indigo-500"
                }`}
              >
                {loading ? "Loading..." : "Apply Filter"}
              </button>
            </div>
          </form>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {charts.map(({ key, label }) => (
            <div key={key} className="bg-white p-4 rounded-lg shadow-md h-auto">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-primary">{label}</h2>
                <div
                  className="px-4 py-2 rounded-2xl flex flex-shrink-0 text-sm"
                  style={{
                    backgroundColor:
                      colorPalette[
                        charts.findIndex((c) => c.key === key) % colorPalette.length
                      ] + "33",
                  }}
                >
                  {apiData?.totals && (
                    <p
                      className="font-semibold text-primary"
                    //   style={{
                    //     color:
                    //       colorPalette[
                    //         charts.findIndex((c) => c.key === key) % colorPalette.length
                    //       ],
                    //   }}
                    >
                      {key === "average_closure_time_minutes"
                        ? apiData.totals[key]?.toFixed(2) || "N/A"
                        : apiData.totals[key] || "N/A"}
                      {key === "average_closure_time_minutes" && " min"}
                    </p>
                  )}
                </div>
              </div>
              <div className="h-64">
                {apiData?.data?.[key]?.length > 0 ? (
                  React.createElement(
                    getChartComponent(chartTypeMap[key][period]),
                    {
                      data: createChartData(key, label),
                      options: getChartOptions(chartTypeMap[key][period]),
                    }
                  )
                ) : (
                  <p className="text-primary text-center">No data available</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Analytics;